function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-159"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-159",
    cx: 251,
    cy: 381.96,
    rx: 227.47,
    ry: 109.28,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-159"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-159",
    cx: 201.25,
    cy: 351.29,
    rx: 98.62,
    ry: 56.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-159",
    cx: 148.91,
    cy: 409.99,
    rx: 88.49,
    ry: 51.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-159",
    cx: 359.9,
    cy: 379.34,
    rx: 98.62,
    ry: 56.94,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.31,118.76c.05,4.71-.12,9.25-6.92,10.31,7.19-.1,6.64,4.43,7,10.11.2-5.68.7-9.75,6.3-10C422.88,128.2,423,125.51,422.31,118.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.13,113.83c0,3.57-.09,7-5.25,7.8,5.45-.07,5,3.36,5.3,7.66.15-4.3.52-7.38,4.77-7.58C46.56,121,46.68,118.94,46.13,113.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,26.63c.06,5.54-.14,10.87-8.14,12.12,8.45-.11,7.81,5.22,8.23,11.89.22-6.67.81-11.46,7.4-11.78C147.26,37.73,147.44,34.57,146.59,26.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1,229.63c0,2.77-.07,5.44-4.08,6.06,4.23-.06,3.91,2.61,4.12,5.95.11-3.34.41-5.73,3.7-5.89C317.43,235.18,317.52,233.6,317.1,229.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.29,154.59c.08,7.19-.18,14.12-10.57,15.73,11-.14,10.15,6.78,10.68,15.45.3-8.67,1.06-14.89,9.62-15.3C399.16,169,399.4,164.9,398.29,154.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,104.53c.07,6-.15,11.85-8.88,13.21,9.22-.12,8.53,5.69,9,13,.24-7.28.88-12.5,8.07-12.85C299.83,116.63,300,113.19,299.09,104.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.34,31.25c0,2.67-.06,5.23-3.91,5.82,4.06,0,3.76,2.51,3.95,5.71.11-3.2.39-5.5,3.56-5.65C377.67,36.59,377.75,35.07,377.34,31.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,249.31c0,2.73-.06,5.35-4,6,4.16-.05,3.84,2.57,4,5.86.11-3.29.4-5.65,3.64-5.8C75.82,254.77,75.9,253.22,75.48,249.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.82,130.78c.07,7.26-.19,14.25-10.68,15.88,11.09-.14,10.25,6.84,10.79,15.6.3-8.76,2.25-15.33,10.89-15.74C73.88,145,72.94,141.19,71.82,130.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,148.46c0,3.68-.74,7.38-6.06,8.2,5.62-.07,5.84,3.32,6.11,7.76.15-4.44,1.37-7.86,5.75-8.07C440.82,155.6,440.11,153.74,439.55,148.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.79,267.21c0,3.94-.79,7.89-6.47,8.77,6-.08,6.24,3.55,6.54,8.29.16-4.74,1.45-8.4,6.14-8.62C457.15,274.85,456.4,272.85,455.79,267.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,283.84c0,3.94-.79,7.89-6.48,8.77,6-.08,6.24,3.55,6.54,8.29.16-4.74,1.46-8.4,6.14-8.62C32.14,291.48,31.38,289.48,30.78,283.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,38.64c.05,5.12-.13,10-7.53,11.2,7.82-.11,7.23,4.82,7.61,11,.21-6.17.75-10.6,6.84-10.89C395.49,48.9,395.66,46,394.87,38.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.72,113.05c0-5.12-.13-9.69-7.53-10.84,7.82.11,7.22-5.18,7.61-11.35C83,97,84,102.32,90,102.61,83.74,103.65,83.51,105.71,82.72,113.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-1--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.81,339.2l8.47,0V356.5h0a22.78,22.78,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45,38.51,38.51,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.78-3.2,1.51-4.88,2.19C225.83,399.23,192,400.46,165,392.23c-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,88.62,88.62,0,0,1,9.44-3.84c22.17-7.67,50.41-8.7,74.41-2.74a106.84,106.84,0,0,1,10.37,3.11c2.79,1,5.49,2.1,8.08,3.32A71.33,71.33,0,0,1,264.49,333,48.27,48.27,0,0,1,271.81,339.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,396l0-35.18,12.88,1.35,0,35.21C190.19,397.11,185.88,396.65,181.65,396Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,356.5h0a22.78,22.78,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.34.38-.7.75-1,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33,340.33l6.61-1.56,0,52.71q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29,396.63l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,220.29,396.63Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,339.76l7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,88.62,88.62,0,0,1,9.44-3.84c3.1-1.08,6.33-2,9.64-2.82l.06,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,370.22c-.45-.68-.87-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61.95,0,36.46A38.45,38.45,0,0,1,130.4,370.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,308.35c-2.59-1.21-5.29-2.31-8.08-3.31a106.84,106.84,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a91.52,91.52,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93A23.2,23.2,0,0,0,126,342a24.9,24.9,0,0,0,3.11,9.13c.38.68.8,1.36,1.25,2a40.46,40.46,0,0,0,8.39,8.92h0q1.75,1.41,3.75,2.76c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.11-1,4.11-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a42.44,42.44,0,0,0,3-3,30.82,30.82,0,0,0,5.91-9.45c.26-.7.5-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.44,27.44,0,0,0-6.37-13.59,46.48,46.48,0,0,0-9.21-8.34A71.35,71.35,0,0,0,253.84,308.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,376.78c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.76-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.76h0a40.46,40.46,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.25-2A24.9,24.9,0,0,1,126,342a23.2,23.2,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,359.93a38.17,38.17,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2A24.9,24.9,0,0,1,126,342a22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.49,380.36c-4.34-.26-8.64-.73-12.86-1.39L159.92,305l1.05-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,377.43c-4.18.93-8.5,1.66-12.88,2.19l-23.89-81.38c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,374.45c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,310.29h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.69.44,1.36.89,2,1.34a46.48,46.48,0,0,1,9.21,8.34,27.44,27.44,0,0,1,6.37,13.59,22.36,22.36,0,0,1-.63,9.26c-.19.71-.43,1.41-.69,2.11a30.82,30.82,0,0,1-5.91,9.45c-.34.38-.7.76-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,316.17c-23.06-10.71-57.42-9.91-78.55,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.43-1.6C267.12,345.18,263.76,326.87,240.71,316.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,316.17c-23.06-10.71-57.42-9.91-78.55,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.43-1.6C267.12,345.18,263.76,326.87,240.71,316.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,317.2c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.61,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.24,74.24,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,239,317.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,317.2c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.61,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.24,74.24,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,239,317.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,322.66c.77.32,1.53.66,2.27,1a45.51,45.51,0,0,1,11.25,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a74.24,74.24,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.13-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.16l.53-.28C183.52,314.56,214.82,313.5,236.79,322.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,322.66c.77.32,1.53.66,2.27,1a45.51,45.51,0,0,1,11.25,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a74.24,74.24,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.13-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.16l.53-.28C183.52,314.56,214.82,313.5,236.79,322.66Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,347.74c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.71-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.37,70,18.67C233.78,379.53,267.31,372.75,278.74,347.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,353.68c8.56,3.58,17,2,24.77-.74L194,355.06V364a37.08,37.08,0,0,0,5.29.86,38.06,38.06,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.17,10.18-6.27v-8.89l-1.91-.81-.42-.18a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.1-6.11.06-8.18,0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-.93.33-1.86.68-2.78,1l2.69-2.8V318.9c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43v8.89l2.36,1a5.51,5.51,0,0,0-.22,1.68V338c.08,1.38-.06,7.26,0,8.82v.07C164.68,349.5,166.83,351.81,171.29,353.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,336.21c0,2.28-.17,6.75-.05,7.77,0,.24,0,.46.06.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S238.3,341.85,238.46,336.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,336.07c-2.26-.94-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19v8.87l-2.67,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a55.34,55.34,0,0,1-8.89,3.27,10,10,0,0,1-3.86.26A7.16,7.16,0,0,1,183.73,336.07Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,336.24l-2.34-1v-8.87l7.51,3.15C167.11,331.85,165.32,334.11,164.73,336.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,354l10.19-6.26v8.88l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71A36.47,36.47,0,0,1,194,364v-8.89a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,359.74a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57.88,57.88,0,0,0,12-1.39c2-.43,3.9-1,5.84-1.61S220.94,360.47,222.87,359.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,346.88v-.05c-.06-1.57.07-7.44,0-8.84.15,2.63,2.28,4.94,6.74,6.81,9.94,4.14,19.61,1.41,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.26,2.15,3.26-1.13,5.36a18.14,18.14,0,0,1-14.2,2.23L196.07,353h0c-7.84,2.77-16.22,4.3-24.76.72C166.82,351.82,164.69,349.5,164.53,346.88Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.21 336.99 198.2 328.1 207.01 318.9 207.02 327.79 198.21 336.99",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.21 336.99 198.2 328.1 207.01 318.9 207.02 327.79 198.21 336.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.38 326.38 169.92 329.52 164.75 336.25 162.39 335.27 162.38 326.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.38 326.38 169.92 329.52 164.75 336.25 162.39 335.27 162.38 326.38",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67,346.93l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10,10,0,0,1-3.84.27,7.82,7.82,0,0,1-1.81-.5c-2.28-.95-2.66-2.72,1.52-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.84-5.39,8.41V338c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.13,3.25-1.16,5.35a18.19,18.19,0,0,1-14.19,2.24L194,355.06a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67,346.93l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.14.15h-.13l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10,10,0,0,1-3.84.27,7.82,7.82,0,0,1-1.81-.5c-2.28-.95-2.66-2.72,1.52-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2L172.45,320l-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.84-5.39,8.41V338c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.13,3.25-1.16,5.35a18.19,18.19,0,0,1-14.19,2.24L194,355.06a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,344.79a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a40,40,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.91,9.91,0,0,0-6-.09,41.33,41.33,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.34,42.34,0,0,1-12.23,2.45,28.27,28.27,0,0,1-6.11-.46A28.62,28.62,0,0,1,171.29,344.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 354.02 230.4 362.91 222.86 359.74 222.85 350.85 230.39 354.02",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.39 354.02 230.4 362.91 222.86 359.74 222.85 350.85 230.39 354.02",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.58 347.75 230.43 353.02 222.85 350.85 230.39 354.02 240.58 347.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 323.1 172.49 320.88 162.38 326.38 172.45 319.95 179.99 323.1",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,318.9a37.45,37.45,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.63,344.92a27.57,27.57,0,0,0,13,1.83L177.35,322l-4.9-2.05-6.87,4.39,1.14,3.85,3.2,1.33a26.31,26.31,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.29,328a26,26,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,327l-1.2.19c-.35.06-.7.12-1.05.21-.14,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91l-1.39.53,2.63,9c4.05-1.6,7.43-2.44,10.38-1.21s2.13,3.25-1.15,5.35a17.71,17.71,0,0,1-7.25,2.62l2.6,8.84a52,52,0,0,0,9.92-3.78l2.84,1.2-7.4-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.69,318.15l8.47,0v17.33h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.34,42.34,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.36-5.5-2.83c-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a106.86,106.86,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.33,71.33,0,0,1,10.64,6.08A49.44,49.44,0,0,1,261.69,318.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.53,374.94l0-35.18,12.88,1.35,0,35.22C180.07,376.06,175.76,375.6,171.53,374.94Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.16,335.45h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.21,319.28l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.17,375.59l0-45.7,12.88.95,0,42.55A129.86,129.86,0,0,1,210.17,375.59Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,318.72l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85q4.66-1.61,9.65-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.36-5.5-2.83c-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,349.17c-.45-.67-.88-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.45A38.1,38.1,0,0,1,120.28,349.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,287.31c-2.59-1.21-5.29-2.32-8.08-3.31a107.71,107.71,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.19,34.19,0,0,0-6.87,8.93A23.13,23.13,0,0,0,115.9,321a25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.28,40.28,0,0,0,8.39,8.93h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29t5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,243.72,287.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,355.74c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.86-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40.28,40.28,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.25-2A24.91,24.91,0,0,1,115.9,321a23.13,23.13,0,0,1,2.65-13.93,34.19,34.19,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,338.88a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2A24.91,24.91,0,0,1,115.9,321a22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.37,359.32c-4.34-.27-8.64-.73-12.86-1.39L149.8,284l1-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,356.38a127,127,0,0,1-12.87,2.19L186.26,277.2c4.49-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,353.41c-2.13.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.54,289.24h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.48,46.48,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26q-.3,1.05-.69,2.1a30.71,30.71,0,0,1-5.92,9.46c-.33.38-.69.75-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,295.12c-23.05-10.7-57.41-9.9-78.54,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.53,1.66-1.07,2.42-1.61C257,324.13,253.64,305.82,230.58,295.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,295.12c-23.05-10.7-57.41-9.9-78.54,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.53,1.66-1.07,2.42-1.61C257,324.13,253.64,305.82,230.58,295.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,296.15c-.74-.34-1.5-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,228.91,296.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,296.15c-.74-.34-1.5-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,228.91,296.15Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.66,301.62c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.68,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.54,19.54,0,0,1,3.87-8.1,34.45,34.45,0,0,1,9.22-7.94c.64-.4,1.3-.78,2-1.15l.53-.29C173.4,293.52,204.7,292.45,226.66,301.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.66,301.62c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.68,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.54,19.54,0,0,1,3.87-8.1,34.45,34.45,0,0,1,9.22-7.94c.64-.4,1.3-.78,2-1.15l.53-.29C173.4,293.52,204.7,292.45,226.66,301.62Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.62,326.69c-8.74,19.44-33.19,27.19-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C223.66,358.48,257.19,351.71,268.62,326.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,332.63c8.56,3.59,17,2,24.77-.73L183.88,334v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.18-6.27v-8.88l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.11.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-.94.33-1.87.68-2.78,1l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43v8.88l2.36,1a5.18,5.18,0,0,0-.22,1.68V317c.07,1.37-.06,7.25,0,8.81v.07C154.56,328.46,156.71,330.77,161.17,332.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,315.17c0,2.27-.16,6.74-.05,7.76,0,.24.05.47.07.71a8.25,8.25,0,0,1-.22,2.08l-5.42-2.28S228.18,320.8,228.33,315.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,315c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.56,13-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.08-.27.11-1.45.55-2.85,1.12-4.19,1.68q-.81.36-1.59.66a55,55,0,0,1-8.9,3.27,10,10,0,0,1-3.85.27A7.16,7.16,0,0,1,173.61,315Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,315.19l-2.34-1v-8.88l7.51,3.15C157,310.8,155.2,313.07,154.61,315.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,333l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51V334a36.47,36.47,0,0,0,14.5.5,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,338.69a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.41,58.41,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S210.82,339.42,212.75,338.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,325.83v-.05c-.07-1.56.07-7.44,0-8.83.16,2.62,2.29,4.94,6.75,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24L186,331.9h0c-7.84,2.77-16.22,4.3-24.76.73C156.69,330.77,154.57,328.46,154.41,325.83Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.08 315.94 188.08 307.05 196.89 297.86 196.9 306.74 188.08 315.94",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.08 315.94 188.08 307.05 196.89 297.86 196.9 306.74 188.08 315.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.26 305.34 159.8 308.48 154.63 315.21 152.27 314.22 152.26 305.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.26 305.34 159.8 308.48 154.63 315.21 152.27 314.22 152.26 305.34",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,325.89l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7l-1.59.67a57.86,57.86,0,0,1-8.9,3.26,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.39,8.41V317c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24L183.88,334a35.9,35.9,0,0,0,5.3.87,38.08,38.08,0,0,0,9.21-.35,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,325.89l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7l-1.59.67a57.86,57.86,0,0,1-8.9,3.26,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.39,8.41V317c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24L183.88,334a35.9,35.9,0,0,0,5.3.87,38.08,38.08,0,0,0,9.21-.35,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,323.75a28.41,28.41,0,0,0,11.8,1.83A43.09,43.09,0,0,0,185,323c4-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.67-7.63,3.41-11.6,4.76A42.35,42.35,0,0,1,173,326a28.91,28.91,0,0,1-6.11-.46A29.29,29.29,0,0,1,161.17,323.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.27 332.98 220.28 341.86 212.74 338.69 212.73 329.81 220.27 332.98",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.27 332.98 220.28 341.86 212.74 338.69 212.73 329.81 220.27 332.98",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.46 326.71 220.31 331.98 212.73 329.81 220.27 332.98 230.46 326.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.87 302.05 162.37 299.83 152.26 305.34 162.32 298.91 169.87 302.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,297.86a37.46,37.46,0,0,0-4.73-.57l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,323.88a27.56,27.56,0,0,0,13,1.82L167.23,301l-4.9-2-6.87,4.38,1.14,3.85,3.2,1.34a28.06,28.06,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,307a26,26,0,0,0-7.49-1.36l8,27.11,6-3.69-1.33-4.52-2.6-1.09a10.71,10.71,0,0,0,1.9-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,305.93l-1.2.19c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09a6.66,6.66,0,0,0-.8.18A60.25,60.25,0,0,0,197,308.5c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.6,7.43-2.45,10.37-1.22s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a51.31,51.31,0,0,0,9.92-3.77l2.84,1.19-7.4-25.22c-.36,0-.74.1-1.1.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.13,297.11l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.78-3.2,1.51-4.88,2.19-24.52,10.14-58.33,11.37-85.31,3.14-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.93-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,89.3,89.3,0,0,1,9.43-3.84c22.18-7.67,50.42-8.7,74.42-2.74a106.84,106.84,0,0,1,10.37,3.11c2.79,1,5.49,2.1,8.08,3.32a71.33,71.33,0,0,1,10.64,6.08A48.76,48.76,0,0,1,265.13,297.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,353.9l0-35.18,12.88,1.35,0,35.21C183.51,355,179.2,354.56,175,353.9Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,314.41h0a23.18,23.18,0,0,1-.83,6.15c-.2.71-.44,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.34.38-.7.75-1.06,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,298.24l6.61-1.56,0,52.71q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,354.54l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,213.61,354.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,297.67l7.75,0c.62-.67,1.27-1.34,2-2a54.76,54.76,0,0,1,9.33-7.08,74.22,74.22,0,0,1,6.67-3.6,89.3,89.3,0,0,1,9.43-3.84c3.11-1.08,6.33-2,9.64-2.82l.07,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.93-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.72,328.13c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61.95,0,36.46A38.45,38.45,0,0,1,123.72,328.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,266.26c-2.59-1.21-5.29-2.31-8.08-3.31a107.69,107.69,0,0,0-10.37-3.11c-24-6-52.24-4.93-74.42,2.73a90.62,90.62,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.35,34.35,0,0,0,122,286,23.13,23.13,0,0,0,119.34,300a25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.36,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-1,2.43-1.93,3.51-2.92a40.23,40.23,0,0,0,3-3,30.67,30.67,0,0,0,5.92-9.45c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26A27.44,27.44,0,0,0,267,280.69a46.28,46.28,0,0,0-9.22-8.34A70.72,70.72,0,0,0,247.16,266.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,334.69c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13A23.13,23.13,0,0,1,122,286a34.35,34.35,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,317.84a38.51,38.51,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,338.27c-4.34-.26-8.64-.73-12.87-1.39L153.24,263l1-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.46,335.34c-4.18.93-8.49,1.66-12.87,2.19L189.7,256.15c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.24,332.36c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,268.2h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.68.44,1.36.89,2,1.34a46.28,46.28,0,0,1,9.22,8.34,27.44,27.44,0,0,1,6.37,13.59,22.36,22.36,0,0,1-.63,9.26c-.2.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,274.08c-23.05-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.66-1.06,2.42-1.6C260.44,303.09,257.08,284.78,234,274.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,274.08c-23.05-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.66-1.06,2.42-1.6C260.44,303.09,257.08,284.78,234,274.08Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,275.11c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.53.28c-.67.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,232.35,275.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,275.11c-.74-.35-1.5-.68-2.27-1-22-9.16-53.27-8.1-72.78,2.42l-.53.28c-.67.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,232.35,275.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,280.57c.78.32,1.53.66,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.78,2-1.16l.53-.28C176.84,272.47,208.14,271.41,230.1,280.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,280.57c.78.32,1.53.66,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.1-9.49,11.67l-.61.44c-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.78,2-1.16l.53-.28C176.84,272.47,208.14,271.41,230.1,280.57Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.06,305.65c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.71-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.37,70,18.66C227.1,337.44,260.63,330.66,272.06,305.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,311.59c8.56,3.58,16.95,2,24.77-.74L187.32,313v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.55,3.17,10.18-6.27v-8.89l-1.92-.81-.41-.18a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.09-6.11.06-8.18,0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.18,27.18,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.15-10.06,6.43v8.89l2.36,1a5.22,5.22,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C158,307.41,160.15,309.72,164.61,311.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,294.12c0,2.28-.16,6.75-.05,7.77,0,.24.05.46.07.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S231.62,299.76,231.77,294.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,294c-2.26-.94-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,13-2.58l8.82-9.19,0,8.87-2.66,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a55,55,0,0,1-8.9,3.27,10,10,0,0,1-3.85.26A7.16,7.16,0,0,1,177.05,294Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,294.15l-2.35-1,0-8.87,7.51,3.15C160.43,289.76,158.64,292,158.05,294.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,311.92l10.19-6.26v8.88l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71,36.47,36.47,0,0,1-14.5-.5V313a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.19,317.65a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57.79,57.79,0,0,0,11.95-1.39c2-.43,3.91-1,5.85-1.61S214.26,318.38,216.19,317.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,304.79v-.05c-.07-1.57.07-7.44,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.41,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.26,2.15,3.26-1.13,5.36a18.14,18.14,0,0,1-14.2,2.23l-7.32,7.55h0c-7.83,2.77-16.21,4.3-24.75.72C160.13,309.73,158,307.41,157.85,304.79Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.52 294.89 191.52 286.01 200.33 276.81 200.34 285.7 191.52 294.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.52 294.89 191.52 286.01 200.33 276.81 200.34 285.7 191.52 294.89",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.7 284.29 163.24 287.44 158.07 294.16 155.71 293.18 155.7 284.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.7 284.29 163.24 287.44 158.07 294.16 155.71 293.18 155.7 284.29",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,304.84l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.14,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24L187.32,313a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,304.84l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.3-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15-10.07,6.43,7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.14,2.61,2.29,4.93,6.76,6.79,9.91,4.16,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24L187.32,313a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,302.7a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a40,40,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.88,9.88,0,0,0-6-.09,41.33,41.33,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76A42.34,42.34,0,0,1,176.39,305a28.27,28.27,0,0,1-6.11-.46A28.62,28.62,0,0,1,164.61,302.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.71 311.93 223.72 320.82 216.18 317.65 216.17 308.76 223.71 311.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.71 311.93 223.72 320.82 216.18 317.65 216.17 308.76 223.71 311.93",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.9 305.66 223.75 310.93 216.17 308.76 223.71 311.93 233.9 305.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.31 281.01 165.81 278.79 155.7 284.29 165.76 277.87 173.31 281.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33,276.81a37.39,37.39,0,0,0-4.74-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,302.83a27.57,27.57,0,0,0,13,1.83l-7.27-24.75-4.9-2.05-6.87,4.39L160,286.1l3.21,1.33a24.84,24.84,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.61,286a26,26,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39,284.88l-1.2.19c-.35.06-.7.12-1.05.21-.15,0-.29.05-.42.09s-.55.1-.8.17a62.61,62.61,0,0,0-6.49,1.91L199,288l2.63,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.62,17.62,0,0,1-7.24,2.62l2.6,8.84a52,52,0,0,0,9.92-3.78L219,310l-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.69,269l8.47,0v17.33h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45,38.43,38.43,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a60.27,60.27,0,0,1-5.09,3.47c-1.92,1.17-3.93,2.26-6,3.29-1.57.77-3.2,1.5-4.87,2.19-24.53,10.13-58.34,11.36-85.31,3.14q-2.77-.84-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0l0-16.39,7.76,0c.61-.67,1.26-1.34,2-2a54.44,54.44,0,0,1,9.34-7.07,71.59,71.59,0,0,1,6.67-3.6,87.63,87.63,0,0,1,9.43-3.85c22.17-7.67,50.42-8.7,74.41-2.74a105.14,105.14,0,0,1,10.38,3.12c2.78,1,5.48,2.1,8.07,3.31a71.33,71.33,0,0,1,10.64,6.08A48.35,48.35,0,0,1,281.69,269Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.53,325.8l0-35.18L204.38,292l0,35.21Q197.9,326.79,191.53,325.8Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.16,286.31h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45c-.33.38-.69.75-1.05,1.13l0-36.2.05.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.21,270.14l6.61-1.56,0,52.72c-2.1.69-4.26,1.33-6.46,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,326.45l0-45.7,12.88.95,0,42.55A129.56,129.56,0,0,1,230.17,326.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,269.57l7.76,0c.61-.67,1.26-1.34,2-2a54.44,54.44,0,0,1,9.34-7.07,71.59,71.59,0,0,1,6.67-3.6,87.63,87.63,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39q-2.87-.71-5.64-1.55t-5.41-1.81c-2.53-.93-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,300c-.45-.67-.87-1.35-1.26-2a25.06,25.06,0,0,1-3.1-9.13,21.66,21.66,0,0,1-.18-2.91h0l0-16.39,7.76,0,.09-.1,2.61.95,0,36.46A38.1,38.1,0,0,1,140.28,300Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,238.17c-2.59-1.21-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.76,90.76,0,0,0-9.44,3.84,75.26,75.26,0,0,0-6.66,3.61,54.44,54.44,0,0,0-9.34,7.07,34.46,34.46,0,0,0-6.87,8.93,23.25,23.25,0,0,0-2.65,13.93A24.91,24.91,0,0,0,139,281c.38.68.81,1.36,1.25,2a40.5,40.5,0,0,0,8.39,8.93h0c1.17.94,2.42,1.87,3.75,2.77s2.75,1.77,4.25,2.63c1.73,1,3.56,1.93,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.38,27.38,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,263.72,238.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,306.59c-1.92-.47-3.82-1-5.68-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.94-.9-3.77-1.85-5.5-2.83-1.5-.86-2.91-1.73-4.25-2.63s-2.58-1.83-3.75-2.77h0a40.5,40.5,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.25,23.25,0,0,1,2.65-13.93,34.46,34.46,0,0,1,6.87-8.93,54.44,54.44,0,0,1,9.34-7.07c1.87-1.15,3.85-2.21,5.9-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,289.74a37.82,37.82,0,0,1-5.84-6.73c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.77,22.77,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,310.17c-4.33-.26-8.63-.73-12.86-1.38L169.8,234.86l1.06-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,307.24a129.56,129.56,0,0,1-12.88,2.19l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,304.27c-2.12.7-4.3,1.34-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,240.1h0c1,.54,2,1.09,2.92,1.66.32.18.63.37.94.56l.94.6c.69.44,1.36.88,2,1.33a45.93,45.93,0,0,1,9.21,8.34,27.38,27.38,0,0,1,6.37,13.6,22.55,22.55,0,0,1-.62,9.26c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,246c-23.06-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C277,275,273.64,256.68,250.59,246Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.59,246c-23.06-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C277,275,273.64,256.68,250.59,246Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,247c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.52.28c-.68.38-1.34.76-2,1.16a34.38,34.38,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.16,20.93,2.58,4,6.77,7.69,12.55,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a73.21,73.21,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.88-2.09a59.36,59.36,0,0,0,6.8-3.05c1-.53,2-1.09,2.95-1.68s1.59-1,2.32-1.53c.21-.14.42-.29.61-.44,4.87-3.56,8-7.55,9.49-11.67,2.52-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,248.91,247Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,247c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.52.28c-.68.38-1.34.76-2,1.16a34.38,34.38,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.16,20.93,2.58,4,6.77,7.69,12.55,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a73.21,73.21,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.88-2.09a59.36,59.36,0,0,0,6.8-3.05c1-.53,2-1.09,2.95-1.68s1.59-1,2.32-1.53c.21-.14.42-.29.61-.44,4.87-3.56,8-7.55,9.49-11.67,2.52-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,248.91,247Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,252.48c.77.31,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.11-9.49,11.67-.19.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.93,1.15-2.95,1.68a59.36,59.36,0,0,1-6.8,3.05c-16.65,6.29-38.69,7.1-56.88,2.09a73.21,73.21,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.89-12.55-10.86a18.83,18.83,0,0,1-2.68-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C193.4,244.37,224.71,243.31,246.67,252.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,252.48c.77.31,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.11-9.49,11.67-.19.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.93,1.15-2.95,1.68a59.36,59.36,0,0,1-6.8,3.05c-16.65,6.29-38.69,7.1-56.88,2.09a73.21,73.21,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.89-12.55-10.86a18.83,18.83,0,0,1-2.68-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C193.4,244.37,224.71,243.31,246.67,252.48Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,277.55c-8.74,19.43-33.18,27.18-53.12,30.68-30.3,4.36-63.28.71-86.71-16.53l.06,0c-6.38-5-11.8-11.73-12.95-19.87,1,8.22,6.24,15.17,12.62,20.32l-.05,0c18.88,14.63,45,19.37,70,18.67C243.66,309.34,277.2,302.56,288.62,277.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.18,283.49c8.55,3.59,16.94,2,24.76-.74l-2.06,2.12v8.89a37.45,37.45,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27v-8.88l-1.91-.82-.41-.18a9.08,9.08,0,0,0,.21-2.07c0-.25,0-.48-.07-.7-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-.93.33-1.86.68-2.78,1l2.69-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42v8.89l2.36,1a5.88,5.88,0,0,0-.22,1.68v.07c.08,1.38,0,7.26,0,8.82v.07C174.57,279.31,176.71,281.63,181.18,283.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,266c0,2.28-.17,6.75-.05,7.77,0,.24.05.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.41-2.28S248.19,271.66,248.34,266Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,265.88c-2.26-.94-2.63-2.7,1.53-5.38,4.46-2.83,9-3.57,12.94-2.59l8.82-9.19v8.88l-2.66,2.8-.28.11c-1.44.55-2.85,1.12-4.18,1.67-.54.25-1.07.47-1.59.67a55.38,55.38,0,0,1-8.9,3.27,10.05,10.05,0,0,1-3.86.27A6.79,6.79,0,0,1,193.61,265.88Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,266.05l-2.35-1v-8.88l7.51,3.15C177,261.66,175.2,263.93,174.62,266.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28,283.82l10.18-6.26v8.88l-10.2,6.29-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,289.55a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.91-1,5.84-1.6S230.82,290.28,232.75,289.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,276.69v-.05c-.06-1.57.07-7.44,0-8.84.16,2.63,2.28,4.94,6.74,6.81,9.94,4.14,19.61,1.42,28.46-2.13,8.22-3.33,14.18-6.86,19-4.86,3,1.27,2.15,3.26-1.14,5.36a18.15,18.15,0,0,1-14.2,2.24L206,282.76h0c-7.84,2.77-16.21,4.3-24.76.72C176.7,281.63,174.58,279.32,174.42,276.69Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.09 266.8 208.08 257.91 216.89 248.71 216.9 257.6 208.09 266.8",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.09 266.8 208.08 257.91 216.89 248.71 216.9 257.6 208.09 266.8",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.26 256.19 179.81 259.34 174.63 266.06 172.27 265.08 172.26 256.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.26 256.19 179.81 259.34 174.63 266.06 172.27 265.08 172.26 256.19",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,276.75l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69-.54.24-1.06.46-1.59.67a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-1-2.66-2.72,1.52-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.55,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,276.75l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.06-.7-.3-2.48-2.37-4.71-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14H227l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69-.54.24-1.06.46-1.59.67a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-1-2.66-2.72,1.52-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.55,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.17,274.61a28.46,28.46,0,0,0,11.8,1.83A43.16,43.16,0,0,0,205,273.89c3.94-1.3,7.74-3,11.61-4.62a39.21,39.21,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40,40,0,0,0-5.84,2.11c-3.82,1.66-7.64,3.41-11.61,4.76A42.62,42.62,0,0,1,193,276.88a28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,181.17,274.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.27 283.83 240.28 292.72 232.74 289.55 232.73 280.67 240.27 283.83",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.27 283.83 240.28 292.72 232.74 289.55 232.73 280.67 240.27 283.83",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.46 277.56 240.31 282.84 232.73 280.67 240.27 283.83 250.46 277.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.87 252.91 182.38 250.69 172.26 256.19 182.33 249.77 189.87 252.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,248.71a39.38,39.38,0,0,0-4.73-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51,274.73a27.46,27.46,0,0,0,13,1.83l-7.26-24.75-4.91-2-6.86,4.38L176.6,258l3.21,1.34a25,25,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,257.85a26.33,26.33,0,0,0-7.48-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11.22,11.22,0,0,0,1.91-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,256.78l-1.19.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.54.1-.79.17a62.82,62.82,0,0,0-6.5,1.92c-.47.16-.92.35-1.39.52l2.63,9c4.06-1.59,7.43-2.44,10.38-1.21s2.14,3.25-1.15,5.36a17.64,17.64,0,0,1-7.24,2.61l2.59,8.84a51.72,51.72,0,0,0,9.92-3.77l2.85,1.19-7.41-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,247.86l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.41-.7,2.1a30.49,30.49,0,0,1-5.91,9.46,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,56.72,56.72,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.77-3.2,1.51-4.88,2.19-24.52,10.14-58.33,11.37-85.31,3.14-1.84-.55-3.64-1.16-5.4-1.81-2.53-.92-5-1.94-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,91.52,91.52,0,0,1,9.43-3.85c22.18-7.66,50.42-8.7,74.42-2.73A106.84,106.84,0,0,1,224,232.24c2.79,1,5.49,2.1,8.08,3.31a71.35,71.35,0,0,1,10.64,6.09A48.27,48.27,0,0,1,250,247.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,304.65l0-35.18,12.88,1.35,0,35.21C168.41,305.77,164.1,305.31,159.87,304.65Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,265.16h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.41-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12l0-36.19.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,249l6.61-1.57,0,52.72q-3.16,1-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,305.29l0-45.69,12.88.95,0,42.55A129.86,129.86,0,0,1,198.51,305.29Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06,248.42l7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,91.52,91.52,0,0,1,9.43-3.85q4.67-1.61,9.65-2.81l.06,73.4c-1.91-.48-3.8-1-5.65-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.77h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,278.88c-.45-.68-.88-1.35-1.26-2a24.85,24.85,0,0,1-3.11-9.12,21.85,21.85,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.45A38.06,38.06,0,0,1,108.62,278.88Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,217c-2.59-1.21-5.29-2.31-8.08-3.31q-5-1.78-10.37-3.12c-24-6-52.24-4.92-74.42,2.74a90.62,90.62,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.46,40.46,0,0,0,8.39,8.92h0q1.77,1.41,3.76,2.76c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3,1.77.66,3.57,1.26,5.41,1.82,27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.55,6-3.29t5.1-3.47q1.88-1.44,3.5-2.92a40.23,40.23,0,0,0,3-3A30.67,30.67,0,0,0,257,256.4c.26-.7.49-1.4.69-2.11a22.36,22.36,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.55,46.55,0,0,0-9.22-8.33A70.72,70.72,0,0,0,232.06,217Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,285.44c-1.92-.48-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0a40.46,40.46,0,0,1-8.39-8.92c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,23.13,23.13,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,268.59a38.17,38.17,0,0,1-5.84-6.73c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,289c-4.34-.26-8.64-.73-12.86-1.39L138.14,213.7l1.05-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,286.09c-4.18.93-8.49,1.66-12.87,2.19L174.6,206.9c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.14,283.11c-2.13.71-4.3,1.35-6.52,1.94l-22.84-77.81c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,219h0c1,.54,2,1.09,2.93,1.65l.94.57.94.59c.68.44,1.36.89,2,1.34a46.76,46.76,0,0,1,9.21,8.33,27.51,27.51,0,0,1,6.37,13.6,22.36,22.36,0,0,1-.63,9.26c-.2.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,224.83c-23-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.42-1.6C245.34,253.84,242,235.53,218.92,224.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,224.83c-23-10.71-57.41-9.91-78.54,1.48-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.38s60.37,9.83,81.17-3c.84-.52,1.66-1.06,2.42-1.6C245.34,253.84,242,235.53,218.92,224.83Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,225.86c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.56,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,217.25,225.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,225.86c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.42l-.52.28c-.68.37-1.34.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a73.42,73.42,0,0,0,7.55,2.52c18.18,5,40.22,4.2,56.88-2.1a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.44c4.86-3.57,8-7.56,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,217.25,225.86Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,231.32c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.67l-.61.44c-.73.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.79,2-1.16l.53-.28C161.74,223.22,193,222.16,215,231.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,231.32c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.21,17.21,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.67l-.61.44c-.73.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.1a73.42,73.42,0,0,1-7.55-2.52c-1.15-.45-2.28-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.16-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.3-.79,2-1.16l.53-.28C161.74,223.22,193,222.16,215,231.32Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,256.4c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.74-12.94-19.88,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.36,70,18.66C212,288.19,245.53,281.41,257,256.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,262.34c8.56,3.58,17,2,24.77-.74l-2.06,2.12v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.17,10.18-6.27v-8.89l-1.91-.82-.42-.17a8.08,8.08,0,0,0,.21-2.07,5.22,5.22,0,0,0-.06-.71c-.13-1.09.1-6.11.06-8.18,0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.15L140.6,235v8.89l2.36,1a5.18,5.18,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C142.9,258.16,145.05,260.47,149.51,262.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67,244.87c0,2.28-.16,6.75,0,7.77,0,.24,0,.46.07.7a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S216.52,250.5,216.67,244.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,244.73c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19,0,8.87-2.66,2.81-.27.1c-1.45.56-2.85,1.13-4.19,1.68-.54.24-1.07.47-1.59.67a53.88,53.88,0,0,1-8.9,3.26,9.81,9.81,0,0,1-3.85.27A7.16,7.16,0,0,1,162,244.73Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,244.9l-2.35-1,0-8.87,7.51,3.15C145.33,240.5,143.54,242.77,143,244.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,262.67l10.19-6.27v8.89l-10.2,6.28-7.52-3.18a48.5,48.5,0,0,1-14.36,4.72,38.07,38.07,0,0,1-9.21.36,38.8,38.8,0,0,1-5.29-.86v-8.89a36.15,36.15,0,0,0,14.5.51,48.79,48.79,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,268.4a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.39,57,57,0,0,0,11.95-1.4c2-.42,3.91-1,5.85-1.6S199.16,269.13,201.09,268.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,255.54v0c-.07-1.57.07-7.45,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.41,28.46-2.14,8.21-3.32,14.18-6.85,19-4.85,3,1.26,2.15,3.26-1.13,5.36a18.18,18.18,0,0,1-14.2,2.23l-7.32,7.55h0c-7.84,2.77-16.22,4.3-24.76.72C145,260.48,142.91,258.16,142.75,255.54Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.42 245.64 176.42 236.76 185.23 227.56 185.24 236.44 176.42 245.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.42 245.64 176.42 236.76 185.23 227.56 185.24 236.44 176.42 245.64",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.6 235.04 148.14 238.18 142.97 244.91 140.61 243.93 140.6 235.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.6 235.04 148.14 238.18 142.97 244.91 140.61 243.93 140.6 235.04",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,255.59l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-1-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.54-3.15L140.6,235l7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.15,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,255.59l-5.83-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.7-.29-2.49-2.36-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.8l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.44.57-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-1-2.65-2.72,1.53-5.39,4.45-2.85,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.54-3.15L140.6,235l7.54,3.14c-3.6,3-5.49,5.84-5.39,8.41v.07c.15,2.61,2.29,4.93,6.76,6.79,9.91,4.15,19.59,1.43,28.43-2.13,8.22-3.33,14.19-6.85,19-4.84,3,1.26,2.14,3.25-1.15,5.35a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38.59,38.59,0,0,0,9.21-.34,49.26,49.26,0,0,0,14.34-4.73l7.54,3.17,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,253.45a28.41,28.41,0,0,0,11.8,1.84,43.44,43.44,0,0,0,12-2.55c4-1.3,7.74-3,11.61-4.63a41.26,41.26,0,0,1,6-2,9.92,9.92,0,0,1,6,.36,9.88,9.88,0,0,0-6-.09,40.13,40.13,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.34,42.34,0,0,1-12.23,2.45,28.27,28.27,0,0,1-6.11-.46A29.29,29.29,0,0,1,149.51,253.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.61 262.68 208.62 271.56 201.07 268.4 201.07 259.51 208.61 262.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.61 262.68 208.62 271.56 201.07 268.4 201.07 259.51 208.61 262.68",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.79 256.41 208.65 261.68 201.07 259.51 208.61 262.68 218.79 256.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.21 231.76 150.71 229.53 140.6 235.04 150.66 228.61 158.21 231.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,227.56a37.45,37.45,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.85,253.58a27.57,27.57,0,0,0,13,1.83l-7.27-24.75-4.9-2L143.8,233l1.14,3.85,3.2,1.33a26.31,26.31,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,236.69a26.31,26.31,0,0,0-7.49-1.36l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,235.63l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.06-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91l-1.39.53,2.63,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.76,17.76,0,0,1-7.24,2.62l2.6,8.83a51.31,51.31,0,0,0,9.92-3.77l2.84,1.2-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.37,218.58l8.46,0v17.33h0A22.74,22.74,0,0,1,287,242c-.19.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45,40.23,40.23,0,0,1-3,3q-1.62,1.49-3.5,2.92a60.48,60.48,0,0,1-5.1,3.47q-2.88,1.74-6,3.29c-1.57.77-3.2,1.5-4.87,2.19-24.53,10.13-58.34,11.36-85.31,3.14-1.84-.56-3.64-1.16-5.41-1.82-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0A40.46,40.46,0,0,1,138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0V219.14l7.75,0c.61-.67,1.26-1.34,1.95-2a54.44,54.44,0,0,1,9.34-7.07,74.07,74.07,0,0,1,6.67-3.61,90.59,90.59,0,0,1,9.43-3.84c22.18-7.67,50.42-8.7,74.41-2.74A105.14,105.14,0,0,1,253.33,203c2.78,1,5.49,2.1,8.07,3.31A70.34,70.34,0,0,1,272,212.36,49,49,0,0,1,279.37,218.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2,275.37l0-35.18,12.88,1.35,0,35.21C197.75,276.49,193.44,276,189.2,275.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.84,235.88h0A22.74,22.74,0,0,1,287,242c-.19.71-.43,1.41-.69,2.11a30.67,30.67,0,0,1-5.92,9.45c-.33.38-.69.75-1.05,1.13l0-36.2.06.06,8.46,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,219.71l6.62-1.56,0,52.71c-2.1.7-4.26,1.34-6.46,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.84,276l0-45.69,12.88,1,0,42.55A126.72,126.72,0,0,1,227.84,276Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,219.14l7.75,0c.61-.67,1.26-1.34,1.95-2a54.44,54.44,0,0,1,9.34-7.07,74.07,74.07,0,0,1,6.67-3.61,90.59,90.59,0,0,1,9.43-3.84c3.1-1.07,6.33-2,9.64-2.81l.06,73.39q-2.87-.71-5.64-1.55c-1.84-.56-3.64-1.16-5.41-1.82-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.76h0A40.46,40.46,0,0,1,138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,249.6c-.45-.68-.87-1.35-1.25-2a24.9,24.9,0,0,1-3.11-9.13,21.76,21.76,0,0,1-.18-2.91h0V219.14l7.75,0,.09-.1,2.61,1,0,36.46A38.1,38.1,0,0,1,138,249.6Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,187.74c-2.59-1.22-5.29-2.32-8.07-3.31a105.14,105.14,0,0,0-10.38-3.12c-24-6-52.24-4.93-74.41,2.74a90.59,90.59,0,0,0-9.43,3.84q-3.51,1.68-6.67,3.6a54.47,54.47,0,0,0-9.34,7.08,34.58,34.58,0,0,0-6.87,8.92,23.29,23.29,0,0,0-2.65,13.94,24.91,24.91,0,0,0,3.11,9.12c.39.68.81,1.36,1.26,2a40.66,40.66,0,0,0,8.38,8.93h0c1.17.94,2.43,1.87,3.76,2.76s2.75,1.78,4.24,2.64c1.73,1,3.57,1.92,5.5,2.83,2.36,1.11,4.82,2.13,7.35,3q2.64,1,5.4,1.81c27,8.22,60.79,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a58.9,58.9,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,42.34,42.34,0,0,0,3-3,30.6,30.6,0,0,0,5.91-9.46c.26-.7.5-1.4.7-2.1a22.55,22.55,0,0,0,.62-9.26,27.26,27.26,0,0,0-6.37-13.6,45.93,45.93,0,0,0-9.21-8.34A71.33,71.33,0,0,0,261.39,187.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,256.16c-1.92-.48-3.81-1-5.68-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.59-1.82-3.76-2.76h0a40.66,40.66,0,0,1-8.38-8.93c-.45-.67-.87-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,23.29,23.29,0,0,1,2.65-13.94,34.58,34.58,0,0,1,6.87-8.92,54.47,54.47,0,0,1,9.34-7.08c1.88-1.14,3.85-2.2,5.9-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77,239.31a37.74,37.74,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a24.91,24.91,0,0,1-3.11-9.12,22.75,22.75,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,259.74c-4.33-.26-8.63-.73-12.86-1.39l-21.7-73.92c.35-.13.69-.26,1.05-.38,3.34-1.16,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7,256.81A129.56,129.56,0,0,1,227.82,259l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.47,253.84c-2.12.7-4.3,1.34-6.52,1.93L222.11,178c2.45.2,4.9.45,7.32.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,189.67h0c1,.54,2,1.09,2.92,1.66.32.18.64.37.94.56l.95.6c.68.44,1.36.88,2,1.33a45.93,45.93,0,0,1,9.21,8.34,27.26,27.26,0,0,1,6.37,13.6A22.55,22.55,0,0,1,287,225c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,195.55c-23-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.17,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C274.67,224.56,271.31,206.25,248.26,195.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,195.55c-23-10.7-57.42-9.91-78.54,1.48-.9.48-1.78,1-2.63,1.51-20.8,12.81-18.17,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C274.67,224.56,271.31,206.25,248.26,195.55Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,196.58c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.77,2.41l-.53.28c-.68.38-1.34.76-2,1.16a34.53,34.53,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.15,20.93,2.57,4,6.76,7.69,12.54,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.89-2.1a58.23,58.23,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.62-.44c4.86-3.57,8-7.55,9.48-11.67,2.53-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,246.58,196.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,196.58c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.11-72.77,2.41l-.53.28c-.68.38-1.34.76-2,1.16a34.53,34.53,0,0,0-9.21,7.93c-5.21,6.7-5.53,14.17-1.15,20.93,2.57,4,6.76,7.69,12.54,10.86,1.08.6,2.22,1.18,3.42,1.73s2.23,1,3.39,1.46a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.2,56.89-2.1a58.23,58.23,0,0,0,6.79-3c1-.53,2-1.09,3-1.68s1.59-1,2.32-1.53l.62-.44c4.86-3.57,8-7.55,9.48-11.67,2.53-7,.21-14.39-6.76-20.64A45.39,45.39,0,0,0,246.58,196.58Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,202.05c.77.31,1.53.65,2.27,1a45.77,45.77,0,0,1,11.26,7.18c4.06,3.65,6.53,7.68,7.39,11.8a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.1-9.48,11.67l-.62.44c-.73.52-1.51,1-2.32,1.53s-1.93,1.15-3,1.68a58.23,58.23,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.1a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.9-12.54-10.86a18.74,18.74,0,0,1-2.69-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.16l.52-.28C191.07,193.94,222.38,192.88,244.34,202.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,202.05c.77.31,1.53.65,2.27,1a45.77,45.77,0,0,1,11.26,7.18c4.06,3.65,6.53,7.68,7.39,11.8a15.92,15.92,0,0,1-.66,2.38c-1.47,4.12-4.62,8.1-9.48,11.67l-.62.44c-.73.52-1.51,1-2.32,1.53s-1.93,1.15-3,1.68a58.23,58.23,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.1a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.39-1.46s-2.34-1.13-3.42-1.73c-5.78-3.17-10-6.9-12.54-10.86a18.74,18.74,0,0,1-2.69-6.36,19.39,19.39,0,0,1,3.87-8.11,34.22,34.22,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.16l.52-.28C191.07,193.94,222.38,192.88,244.34,202.05Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,227.12c-8.74,19.43-33.18,27.18-53.12,30.68-30.3,4.35-63.28.71-86.7-16.53l.05,0c-6.37-5-11.8-11.73-13-19.87,1,8.22,6.25,15.17,12.62,20.32l-.05,0c18.88,14.63,45,19.37,70,18.67C241.33,258.91,274.87,252.13,286.29,227.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,233.06c8.56,3.59,16.94,2,24.76-.74l-2.06,2.12v8.89a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,48.85,48.85,0,0,0,14.34-4.72l7.54,3.17L248.14,236v-8.89l-1.91-.81-.41-.18a9.08,9.08,0,0,0,.21-2.07c0-.25,0-.48-.07-.71-.13-1.09.1-6.11.06-8.18a5.07,5.07,0,0,0-.06-.7c-.3-2.48-2.37-4.72-6.58-6.47v0a27.17,27.17,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-.93.32-1.86.68-2.77,1l2.68-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42v8.89l2.36,1a5.84,5.84,0,0,0-.22,1.68v.07c.08,1.38-.05,7.26,0,8.82v.07C172.24,228.88,174.38,231.2,178.85,233.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,215.59c0,2.28-.17,6.75,0,7.77,0,.24,0,.46.06.7a8.82,8.82,0,0,1-.21,2.09l-5.42-2.28S245.86,221.23,246,215.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,215.45c-2.26-.94-2.63-2.7,1.53-5.38,4.46-2.83,9-3.57,12.94-2.59l8.82-9.19v8.88L211.9,210l-.28.1c-1.44.56-2.84,1.13-4.18,1.68-.54.25-1.07.47-1.59.67a55.38,55.38,0,0,1-8.9,3.27,10,10,0,0,1-3.86.26A6.42,6.42,0,0,1,191.28,215.45Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,215.62l-2.35-1v-8.88l7.52,3.15C174.66,211.23,172.87,213.5,172.29,215.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,233.39l10.18-6.26V236l-10.2,6.29-7.52-3.18a48.78,48.78,0,0,1-14.36,4.71,38,38,0,0,1-9.21.37,38.85,38.85,0,0,1-5.29-.87v-8.89a36.19,36.19,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.42,239.12A37.16,37.16,0,0,1,219,243.8a30.69,30.69,0,0,1-12.13.4,58.5,58.5,0,0,0,12-1.4c2-.43,3.91-1,5.84-1.6S228.49,239.85,230.42,239.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.09,226.26v0c-.06-1.57.07-7.44,0-8.84.16,2.63,2.28,4.94,6.75,6.81,9.93,4.14,19.6,1.42,28.45-2.13,8.22-3.33,14.19-6.86,19-4.86,3,1.27,2.15,3.26-1.14,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.83,2.77-16.21,4.3-24.75.72C174.37,231.2,172.25,228.89,172.09,226.26Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.76 216.37 205.75 207.48 214.56 198.28 214.57 207.17 205.76 216.37",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.76 216.37 205.75 207.48 214.56 198.28 214.57 207.17 205.76 216.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 205.76 177.48 208.91 172.3 215.63 169.94 214.65 169.94 205.76",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.94 205.76 177.48 208.91 172.3 215.63 169.94 214.65 169.94 205.76",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.22,226.32l-5.83-2.46s5.73-2.77,5.62-8.68a5.07,5.07,0,0,0-.06-.7c-.3-2.49-2.37-4.72-6.58-6.47v0a27.06,27.06,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-1,.35-2,.74-3,1.14-1.44.56-2.85,1.14-4.2,1.69-.54.24-1.06.46-1.58.67a57.78,57.78,0,0,1-8.9,3.27,10.21,10.21,0,0,1-3.85.26,7.47,7.47,0,0,1-1.81-.5c-2.27-1-2.65-2.71,1.52-5.39,4.46-2.84,9.05-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42,7.54,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.3,4.93,6.76,6.79,9.91,4.16,19.6,1.43,28.44-2.12,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.22,226.32l-5.83-2.46s5.73-2.77,5.62-8.68a5.07,5.07,0,0,0-.06-.7c-.3-2.49-2.37-4.72-6.58-6.47v0a27.06,27.06,0,0,0-13.47-1.79l-1.15.14h-.13l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-1,.35-2,.74-3,1.14-1.44.56-2.85,1.14-4.2,1.69-.54.24-1.06.46-1.58.67a57.78,57.78,0,0,1-8.9,3.27,10.21,10.21,0,0,1-3.85.26,7.47,7.47,0,0,1-1.81-.5c-2.27-1-2.65-2.71,1.52-5.39,4.46-2.84,9.05-3.58,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2L180,199.34l-10.06,6.42,7.54,3.15c-3.6,3-5.5,5.83-5.4,8.4v.07c.15,2.62,2.3,4.93,6.76,6.79,9.91,4.16,19.6,1.43,28.44-2.12,8.22-3.33,14.18-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.64a39,39,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49,49,0,0,0,14.34-4.72l7.54,3.16,10.19-6.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84,224.17a28.47,28.47,0,0,0,11.8,1.84,43.16,43.16,0,0,0,12.05-2.55c3.94-1.3,7.74-3,11.61-4.62a39.21,39.21,0,0,1,5.95-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40,40,0,0,0-5.84,2.11c-3.82,1.66-7.64,3.41-11.61,4.76a42.27,42.27,0,0,1-12.23,2.45,28.13,28.13,0,0,1-6.1-.45A29.19,29.19,0,0,1,178.84,224.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 233.4 237.95 242.29 230.41 239.12 230.4 230.24 237.94 233.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 233.4 237.95 242.29 230.41 239.12 230.4 230.24 237.94 233.4",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.13 227.13 237.98 232.41 230.4 230.24 237.94 233.4 248.13 227.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.54 202.48 180.05 200.26 169.94 205.76 180 199.34 187.54 202.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,198.28a37.23,37.23,0,0,0-4.73-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,224.3a27.48,27.48,0,0,0,13,1.83l-7.26-24.75-4.91-2-6.86,4.38,1.13,3.85,3.21,1.34a23.56,23.56,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,207.42a26.33,26.33,0,0,0-7.48-1.37l8,27.12,6-3.69L243,225l-2.6-1.1a11.22,11.22,0,0,0,1.91-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62,206.35l-1.19.2c-.35.06-.7.11-1.05.2-.15,0-.3.05-.42.09-.28,0-.55.1-.8.17a60.45,60.45,0,0,0-6.5,1.92c-.46.16-.92.35-1.39.52l2.64,9c4.05-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.59,8.84a51.47,51.47,0,0,0,9.92-3.77l2.85,1.19-7.41-25.23-1.09.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "139.37 221.26 140.6 211.94 141.83 221.26 157.97 221.97 141.83 222.68 140.6 232 139.37 222.68 123.23 221.97 139.37 221.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.73 228.27 153.32 223.75 153.92 228.27 161.74 228.61 153.92 228.96 153.32 233.48 152.73 228.96 144.9 228.61 152.73 228.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.92 274.35 119.15 265.03 120.38 274.35 136.53 275.06 120.38 275.77 119.15 285.09 117.92 275.77 101.78 275.06 117.92 274.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.65 281.58 127.24 277.06 127.84 281.58 135.66 281.92 127.84 282.26 127.24 286.78 126.65 282.26 118.82 281.92 126.65 281.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.46,137a78.38,78.38,0,0,0,.61,10.1,76.92,76.92,0,0,0,55,64.16,77.47,77.47,0,0,0,21,3,77.49,77.49,0,0,0,16.08-1.61,77.17,77.17,0,0,0,49.28-34.2c.71-1.12,1.39-2.27,2.05-3.42a76.55,76.55,0,0,0,7.09-17.19h0c.56-2,1-4.1,1.44-6.2s.71-4.23.93-6.4q.39-3.75.4-7.59a76,76,0,0,0-.51-9.23q-.36-3.18-1-6.27a77,77,0,0,0-60.26-60.26c-2.06-.42-4.16-.75-6.28-1a75.74,75.74,0,0,0-8.58-.51,74.73,74.73,0,0,0-8.23.4c-2.16.21-4.3.53-6.4.93s-4.17.87-6.21,1.43a76.12,76.12,0,0,0-17.19,7.1c-1.16.65-2.31,1.33-3.43,2a77.42,77.42,0,0,0-28.46,32.2,76,76,0,0,0-5.73,17.09A77.55,77.55,0,0,0,115.46,137Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,137a78.38,78.38,0,0,0,.61,10.1,76.92,76.92,0,0,0,55,64.16,77.47,77.47,0,0,0,21,3,77.49,77.49,0,0,0,16.08-1.61,77.17,77.17,0,0,0,49.28-34.2c.71-1.12,1.39-2.27,2.05-3.42a76.55,76.55,0,0,0,7.09-17.19h0c.56-2,1-4.1,1.44-6.2s.71-4.23.93-6.4q.39-3.75.4-7.59a76,76,0,0,0-.51-9.23q-.36-3.18-1-6.27a77,77,0,0,0-60.26-60.26c-2.06-.42-4.16-.75-6.28-1a75.74,75.74,0,0,0-8.58-.51,74.73,74.73,0,0,0-8.23.4c-2.16.21-4.3.53-6.4.93s-4.17.87-6.21,1.43a76.12,76.12,0,0,0-17.19,7.1c-1.16.65-2.31,1.33-3.43,2a77.42,77.42,0,0,0-28.46,32.2,76,76,0,0,0-5.73,17.09A77.55,77.55,0,0,0,115.46,137Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,116c.58,2,1.09,4.08,1.51,6.18s.75,4.15,1,6.27a76,76,0,0,1,.51,9.23q0,3.84-.4,7.59-.33,3.26-.93,6.4c-.4,2.1-.88,4.16-1.44,6.2h0A76.55,76.55,0,0,1,259.48,175c-.66,1.15-1.34,2.3-2.05,3.42a76.76,76.76,0,0,1-65.36,35.81,77.63,77.63,0,0,1-8.4-.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,162.44A75.86,75.86,0,0,1,259.48,175c-.66,1.15-1.34,2.3-2.05,3.42a77.19,77.19,0,0,1-28.11,26.37Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,93.73a75.63,75.63,0,0,1,6.46,11.36l-90,106.49-1.22-.33a76.1,76.1,0,0,1-11-4.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,68.27a77.92,77.92,0,0,1,11.52,7L138.81,192.49A77.23,77.23,0,0,1,130,182.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,63.8q3.57,1.11,7,2.54L127.39,178.42c-1.32-2.09-2.57-4.23-3.69-6.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.68,131.76h0c.1-1.42.25-2.83.42-4.22.06-.47.11-.94.18-1.4s.14-1,.22-1.43c.18-1,.36-2.1.57-3.14A76.78,76.78,0,0,1,137.8,83.11a77.27,77.27,0,0,1,13.46-10.83c1.12-.71,2.27-1.39,3.43-2a76.12,76.12,0,0,1,17.19-7.1c.76-.21,1.52-.39,2.29-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,137.32a57.32,57.32,0,0,0,53.49,57.2c1.26.08,2.56.13,3.85.13a57.34,57.34,0,0,0,0-114.67c-1.29,0-2.59,0-3.85.13A57.34,57.34,0,0,0,135.07,137.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,137.32a57.32,57.32,0,0,0,53.49,57.2c1.26.08,2.56.13,3.85.13a57.34,57.34,0,0,0,0-114.67c-1.29,0-2.59,0-3.85.13A57.34,57.34,0,0,0,135.07,137.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,137.32c0,1,0,2,.08,2.92a54.77,54.77,0,0,0,51,51.73l.75.05c1,0,1.94.08,2.92.08A54.72,54.72,0,0,0,247,142c.14-1.55.2-3.11.2-4.7s-.05-2.89-.16-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,54.7,54.7,0,0,0-27.43,47.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,137.32c0,1,0,2,.08,2.92a54.77,54.77,0,0,0,51,51.73l.75.05c1,0,1.94.08,2.92.08A54.72,54.72,0,0,0,247,142c.14-1.55.2-3.11.2-4.7s-.05-2.89-.16-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,54.7,54.7,0,0,0-27.43,47.48Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,176.19A54.41,54.41,0,0,0,247,142c.14-1.55.21-3.11.21-4.7s-.06-2.89-.17-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,55.09,55.09,0,0,0-6.86,4.75,54.46,54.46,0,0,0-16.12,38.78c0,1,0,1.95.09,2.92a54.75,54.75,0,0,0,51,51.73l.74,0c1,.05,1.95.08,2.93.08a54.38,54.38,0,0,0,34.13-12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,176.19A54.41,54.41,0,0,0,247,142c.14-1.55.21-3.11.21-4.7s-.06-2.89-.17-4.31a53.16,53.16,0,0,0-1.4-8.73A54.87,54.87,0,0,0,205.44,84.1a53.16,53.16,0,0,0-8.73-1.4c-1.42-.11-2.86-.16-4.31-.16-1.23,0-2.46,0-3.67.12-.34,0-.68,0-1,.08a54.3,54.3,0,0,0-22.65,7.1,55.09,55.09,0,0,0-6.86,4.75,54.46,54.46,0,0,0-16.12,38.78c0,1,0,1.95.09,2.92a54.75,54.75,0,0,0,51,51.73l.74,0c1,.05,1.95.08,2.93.08a54.38,54.38,0,0,0,34.13-12Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,70.24c33.11-17.15,60-8.23,78,2.47,26,17.45,42.4,46.68,33.43,85.31v-.08a75.94,75.94,0,0,1-19.54,34A77.56,77.56,0,0,0,267,157.64v.07c8.27-32-2.13-57.41-19.48-75.34C228.93,65.23,197.43,48.3,154.69,70.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,96.83l-.06,7.38s-7.59-1.34-16.24,5.49c-.36.29-.68.57-1,.85a16,16,0,0,0-5.52,12.55l0,0a16,16,0,0,0,5.6,12.64c.29.25.63.48.92.73l.09.09,1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c1.15.4,2.34.76,3.53,1.09,1.72.49,3.44.94,5.08,1.36l2,.49c4.68,1.13,8.09,2.05,10.25,3.27a5.58,5.58,0,0,1,2.75,2.72,5.34,5.34,0,0,1,.38,2c0,2.87-2.39,5.19-8.89,5-6.92-.26-10.81-3-11.74-7.22l-19,3.56c2.87,8.7,10.6,14.38,22.73,16.46l0,9.51,15.64.58,0-9.51c6.57-.55,12-2.34,15.7-5.35l.1-.08a16.11,16.11,0,0,0,5.88-13.06c.06-12.53-9.89-17-20.54-19.92-9.95-2.67-18.8-3.33-18.78-9.42,0-3.8,3.48-5.38,8.6-5.2,8.17.29,11.35,5.11,12,8.61l20-3.63a21.87,21.87,0,0,0-2-5.15,20.78,20.78,0,0,0-6.15-6.85c-4.44-3.2-10.08-5-15.74-5.88l0-9.54-15.48-.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,96.83l-.06,7.38s-7.59-1.34-16.24,5.49c-.36.29-.68.57-1,.85a16,16,0,0,0-5.52,12.55l0,0a16,16,0,0,0,5.6,12.64c.29.25.63.48.92.73l.09.09,1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c1.15.4,2.34.76,3.53,1.09,1.72.49,3.44.94,5.08,1.36l2,.49c4.68,1.13,8.09,2.05,10.25,3.27a5.58,5.58,0,0,1,2.75,2.72,5.34,5.34,0,0,1,.38,2c0,2.87-2.39,5.19-8.89,5-6.92-.26-10.81-3-11.74-7.22l-19,3.56c2.87,8.7,10.6,14.38,22.73,16.46l0,9.51,15.64.58,0-9.51c6.57-.55,12-2.34,15.7-5.35l.1-.08a16.11,16.11,0,0,0,5.88-13.06c.06-12.53-9.89-17-20.54-19.92-9.95-2.67-18.8-3.33-18.78-9.42,0-3.8,3.48-5.38,8.6-5.2,8.17.29,11.35,5.11,12,8.61l20-3.63a21.87,21.87,0,0,0-2-5.15,20.78,20.78,0,0,0-6.15-6.85c-4.44-3.2-10.08-5-15.74-5.88l0-9.54-15.48-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24,152.24a16.79,16.79,0,0,0-4.51-11.37c-2.78-3-6.74-5-11.14-6.56s-9.21-2.62-13.93-3.85a29.74,29.74,0,0,1-6.57-2.42,5.61,5.61,0,0,1-3.17-5.14c.07,2.29,1.56,3.83,3.53,4.8a31.14,31.14,0,0,0,6.7,2.18,131.9,131.9,0,0,1,14.12,3.69c4.38,1.61,8.42,3.68,11.11,6.82a15.6,15.6,0,0,1,3.06,5.32A21,21,0,0,1,222.24,152.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.19 94.4 198.18 96.36 199.62 104.8 199.67 95.26 184.19 94.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.92 170.15 186.23 178.57 200.54 180.24 184.91 179.66 184.92 170.15",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,153.69a21,21,0,0,0,2.07,4.36l5.46-5.77Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,151.83a16.15,16.15,0,0,0-5.25-12.3l-32.05,33.94,0,6.19,10.67.4,5-5.29v-4a43.93,43.93,0,0,0,4.37-.59Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.41,125a15.71,15.71,0,0,0,2.57,7.44L199.1,95.22l-9.12-.5-5.85,6.2,0,3.29a13.45,13.45,0,0,0-3.05,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.93,136.58l1,.72a9.93,9.93,0,0,0,.94.59,4.35,4.35,0,0,0,.39.23,5.16,5.16,0,0,0,.75.43,43.79,43.79,0,0,0,6.8,2.92c.53.18,1.08.33,1.62.5l11.61-12.29c-4.84-1.37-8.15-3.06-8.14-6.78s3.48-5.38,8.6-5.2a13.87,13.87,0,0,1,8.29,2.71l11.44-12.12a41.68,41.68,0,0,0-11.63-3.5l0-3.59L167,135.79c.28.24.6.47.87.7Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "143.19 91.23 144.46 74.51 145.73 91.23 162.45 92.5 145.73 93.78 144.46 110.49 143.19 93.78 126.47 92.5 143.19 91.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.3 104.95 156.92 96.84 157.53 104.95 165.64 105.56 157.53 106.18 156.92 114.28 156.3 106.18 148.2 105.56 156.3 104.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.55,365.53l8.47,0v17.33h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45,40.43,40.43,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92A58.9,58.9,0,0,1,421,410c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.93-5-1.94-7.35-3.05-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.76h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a106.86,106.86,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.33,71.33,0,0,1,10.64,6.08A48.85,48.85,0,0,1,431.55,365.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,422.32l0-35.18,12.88,1.35,0,35.21C349.93,423.44,345.62,423,341.39,422.32Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,382.83h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.45,30.45,0,0,1-5.91,9.45c-.34.38-.7.75-1.06,1.13l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.07,366.66l6.61-1.56,0,52.72q-3.16,1-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,423l0-45.7,12.88,1,0,42.55A129.86,129.86,0,0,1,380,423Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,366.09l7.75,0c.62-.67,1.27-1.34,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,89.34,89.34,0,0,1,9.43-3.85q4.66-1.6,9.65-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.93-5-1.94-7.35-3.05-1.94-.91-3.77-1.85-5.5-2.84-1.49-.85-2.91-1.73-4.24-2.63s-2.59-1.82-3.76-2.76h0a40.4,40.4,0,0,1-8.38-8.92c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,396.55c-.45-.67-.88-1.35-1.26-2a24.9,24.9,0,0,1-3.11-9.13,21.65,21.65,0,0,1-.17-2.91h0l0-16.39,7.75,0,.1-.1,2.61,1,0,36.46A38.1,38.1,0,0,1,290.14,396.55Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,334.69c-2.59-1.21-5.29-2.32-8.08-3.31a105,105,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34,34,0,0,0-6.87,8.93,23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40.5,40.5,0,0,0,8.39,8.93h0c1.18.94,2.43,1.87,3.76,2.77s2.75,1.77,4.25,2.63c1.72,1,3.56,1.93,5.49,2.83,2.36,1.11,4.82,2.13,7.35,3.05q2.65,1,5.41,1.81c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19,2.1-1,4.11-2.12,6-3.29s3.53-2.28,5.1-3.47c1.25-.95,2.42-1.93,3.5-2.92a38.34,38.34,0,0,0,3-3,30.71,30.71,0,0,0,5.92-9.46q.39-1.05.69-2.1a22.38,22.38,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.48,46.48,0,0,0-9.21-8.34A71.33,71.33,0,0,0,413.58,334.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,403.11c-1.92-.47-3.82-1-5.68-1.56s-3.64-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.91-1.73-4.25-2.63s-2.58-1.83-3.76-2.77h0a40.5,40.5,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12,23.1,23.1,0,0,1,2.65-13.93,34,34,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,386.26a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,406.69c-4.34-.26-8.64-.73-12.86-1.38l-21.71-73.93,1-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,403.76A129.86,129.86,0,0,1,380,406l-23.89-81.37c4.49-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,400.79q-3.2,1.05-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,336.62h0c1,.54,2,1.09,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.48,46.48,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.38,22.38,0,0,1-.63,9.26q-.3,1-.69,2.1a30.71,30.71,0,0,1-5.92,9.46c-.33.38-.69.75-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,342.5C377.39,331.8,343,332.59,321.9,344c-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.52,1.66-1.06,2.42-1.6C426.86,371.51,423.5,353.2,400.44,342.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,342.5C377.39,331.8,343,332.59,321.9,344c-.89.48-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.84-.52,1.66-1.06,2.42-1.6C426.86,371.51,423.5,353.2,400.44,342.5Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,343.53c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.53.28c-.67.38-1.33.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.86,1.09.6,2.23,1.18,3.43,1.73s2.23,1,3.38,1.46a73.39,73.39,0,0,0,7.55,2.51c18.18,5,40.22,4.2,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.53c.21-.14.41-.29.61-.44,4.86-3.56,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,398.77,343.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,343.53c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.11-72.78,2.41l-.53.28c-.67.38-1.33.76-2,1.16a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.93,2.57,4,6.76,7.69,12.54,10.86,1.09.6,2.23,1.18,3.43,1.73s2.23,1,3.38,1.46a73.39,73.39,0,0,0,7.55,2.51c18.18,5,40.22,4.2,56.88-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.53c.21-.14.41-.29.61-.44,4.86-3.56,8-7.55,9.49-11.67,2.52-7,.2-14.39-6.76-20.64A45.77,45.77,0,0,0,398.77,343.53Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,349c.78.31,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.11-9.49,11.67-.2.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.29-38.7,7.1-56.88,2.09a73.39,73.39,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.46s-2.34-1.13-3.43-1.73c-5.78-3.17-10-6.89-12.54-10.86a18.86,18.86,0,0,1-2.69-6.36,19.63,19.63,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C343.26,340.89,374.56,339.83,396.52,349Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,349c.78.31,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.21,17.21,0,0,1-.66,2.38c-1.48,4.12-4.63,8.11-9.49,11.67-.2.15-.4.3-.61.44-.73.52-1.51,1-2.32,1.53s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.29-38.7,7.1-56.88,2.09a73.39,73.39,0,0,1-7.55-2.51c-1.15-.46-2.28-.94-3.38-1.46s-2.34-1.13-3.43-1.73c-5.78-3.17-10-6.89-12.54-10.86a18.86,18.86,0,0,1-2.69-6.36,19.63,19.63,0,0,1,3.87-8.11,34.43,34.43,0,0,1,9.22-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C343.26,340.89,374.56,339.83,396.52,349Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.48,374.07c-8.74,19.43-33.19,27.18-53.12,30.68-30.3,4.36-63.28.71-86.71-16.53l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.17,12.61,20.32l0,0c18.87,14.63,45,19.37,70,18.67C393.52,405.86,427.05,399.09,438.48,374.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,380c8.56,3.59,17,2,24.77-.74l-2.06,2.12v8.89a37.08,37.08,0,0,0,5.29.86,38.59,38.59,0,0,0,9.21-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17L400.32,383v-8.88l-1.91-.82-.42-.18a8.08,8.08,0,0,0,.21-2.07,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.94.33-1.87.68-2.78,1l2.69-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42v8.89l2.36,1a5.25,5.25,0,0,0-.22,1.68v.07c.07,1.38-.06,7.26,0,8.82v.07C324.42,375.83,326.57,378.15,331,380Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.19,362.54c0,2.28-.16,6.75,0,7.77,0,.24,0,.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.42-2.28S398,368.18,398.19,362.54Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,362.41c-2.26-1-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.57,12.95-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.07-.27.11-1.45.55-2.85,1.12-4.19,1.67-.54.25-1.07.47-1.59.67a55.34,55.34,0,0,1-8.89,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,343.47,362.41Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47,362.57l-2.34-1v-8.88l7.51,3.15C326.85,358.18,325.06,360.45,324.47,362.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,380.34l10.19-6.26V383l-10.2,6.29-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.61,386.07a37.16,37.16,0,0,1-11.44,4.68,30.51,30.51,0,0,1-12.13.4,58.49,58.49,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S380.68,386.8,382.61,386.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.27,373.21v0c-.07-1.57.07-7.44,0-8.84.16,2.63,2.29,4.94,6.75,6.81,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.33,14.18-6.86,19-4.86,3,1.27,2.15,3.26-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.84,2.77-16.22,4.3-24.76.73C326.56,378.15,324.43,375.84,324.27,373.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.94 363.32 357.94 354.43 366.75 345.23 366.75 354.12 357.94 363.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.94 363.32 357.94 354.43 366.75 345.23 366.75 354.12 357.94 363.32",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.12 352.71 329.66 355.86 324.49 362.58 322.13 361.6 322.12 352.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.12 352.71 329.66 355.86 324.49 362.58 322.13 361.6 322.12 352.71",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,373.27l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69l-1.59.67a57,57,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.54,3.15c-3.6,3-5.49,5.83-5.39,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36.42,36.42,0,0,0,14.51.52,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,373.27l-5.83-2.46s5.73-2.77,5.62-8.68c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.58-6.47v0a27.27,27.27,0,0,0-13.47-1.79l-1.15.14h-.12l-1.2.2c-.35.06-.7.12-1.05.2-.15,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.69l-1.59.67a57,57,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-1-2.65-2.72,1.53-5.4,4.45-2.84,9-3.58,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.42,7.54,3.15c-3.6,3-5.49,5.83-5.39,8.4v.07c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.26,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36.42,36.42,0,0,0,14.51.52,49.25,49.25,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,371.13a28.41,28.41,0,0,0,11.8,1.83,43.09,43.09,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.66-7.63,3.41-11.6,4.76a42.35,42.35,0,0,1-12.23,2.46,28.91,28.91,0,0,1-6.11-.46A29.29,29.29,0,0,1,331,371.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.13 380.35 390.14 389.24 382.6 386.07 382.59 377.19 390.13 380.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.13 380.35 390.14 389.24 382.6 386.07 382.59 377.19 390.13 380.35",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.32 374.08 390.17 379.36 382.59 377.19 390.13 380.35 400.32 374.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.73 349.43 332.23 347.21 322.12 352.71 332.19 346.29 339.73 349.43",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,345.23a39.38,39.38,0,0,0-4.73-.56l1.23,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,371.25a27.45,27.45,0,0,0,13,1.83l-7.27-24.75-4.9-2-6.87,4.38,1.14,3.85,3.2,1.34a26.27,26.27,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,354.37a26.33,26.33,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.1a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,353.3l-1.2.2c-.35.06-.7.12-1.05.2-.14,0-.29.05-.42.09s-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.59,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a52,52,0,0,0,9.92-3.77l2.84,1.19L378,353.15l-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.43,344.48l8.47,0v17.34h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46,40.34,40.34,0,0,1-3,3,43.27,43.27,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.27-6,3.29-1.58.77-3.2,1.51-4.88,2.19-24.52,10.13-58.33,11.37-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.51,40.51,0,0,1,280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V345.05l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,90.62,90.62,0,0,1,9.43-3.85c22.18-7.66,50.42-8.7,74.42-2.74q5.36,1.33,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a71.35,71.35,0,0,1,10.64,6.09A49.31,49.31,0,0,1,421.43,344.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.27,401.27l0-35.17,12.88,1.34,0,35.22C339.81,402.4,335.5,401.93,331.27,401.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.9,361.79h0a23.18,23.18,0,0,1-.83,6.15c-.2.7-.44,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.12l0-36.19.06.05,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,345.62l6.61-1.57,0,52.72q-3.16,1.05-6.47,1.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,401.92l0-45.69,12.88.94,0,42.56C378.6,400.66,374.29,401.39,369.91,401.92Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46,345.05l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,90.62,90.62,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.4c-1.9-.48-3.79-1-5.64-1.56s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.51,40.51,0,0,1,280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,375.5c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V345.05l7.75,0a.94.94,0,0,1,.1-.1l2.61.95,0,36.45A38.23,38.23,0,0,1,280,375.5Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,313.64c-2.59-1.21-5.29-2.31-8.08-3.31-3.34-1.19-6.81-2.23-10.37-3.12-24-6-52.24-4.92-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07,34.35,34.35,0,0,0-6.87,8.93,23.13,23.13,0,0,0-2.65,13.93,25.06,25.06,0,0,0,3.1,9.13c.39.68.81,1.35,1.26,2a40.23,40.23,0,0,0,8.39,8.92h0q1.77,1.43,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.11,4.82,2.12,7.35,3q2.64,1,5.41,1.82c27,8.22,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.2q3.15-1.53,6-3.29a55.88,55.88,0,0,0,5.09-3.47,45.27,45.27,0,0,0,3.51-2.92,38.34,38.34,0,0,0,3-3,30.56,30.56,0,0,0,5.91-9.45c.27-.7.5-1.4.7-2.11a22.53,22.53,0,0,0,.63-9.26,27.51,27.51,0,0,0-6.37-13.6,46.24,46.24,0,0,0-9.22-8.33A70.72,70.72,0,0,0,403.46,313.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,382.07c-1.92-.48-3.82-1-5.68-1.56s-3.65-1.17-5.41-1.82c-2.53-.92-5-1.93-7.35-3-1.93-.91-3.77-1.85-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40.23,40.23,0,0,1-8.39-8.92c-.45-.68-.87-1.35-1.26-2a25,25,0,0,1-3.1-9.12,23.13,23.13,0,0,1,2.65-13.93,34.35,34.35,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.14,3.86-2.21,5.91-3.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.83,365.21a38.46,38.46,0,0,1-5.83-6.72c-.45-.68-.87-1.35-1.26-2a25,25,0,0,1-3.1-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.11,385.65c-4.34-.27-8.64-.73-12.87-1.39l-21.7-73.93,1-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,382.72c-4.18.93-8.49,1.66-12.87,2.19L346,303.53c4.49-.2,9-.18,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,379.74q-3.19,1.06-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.28,315.57h0c1,.55,2,1.1,2.93,1.66l.94.57c.32.19.63.39.94.59.68.44,1.36.89,2,1.34a46.24,46.24,0,0,1,9.22,8.33,27.51,27.51,0,0,1,6.37,13.6,22.53,22.53,0,0,1-.63,9.26c-.2.71-.43,1.41-.7,2.11a30.56,30.56,0,0,1-5.91,9.45c-.33.38-.69.76-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,321.45c-23.05-10.7-57.42-9.9-78.54,1.49-.89.48-1.78,1-2.63,1.51-20.79,12.8-18.17,32.22,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.65-1.06,2.42-1.6C416.74,350.47,413.38,332.16,390.32,321.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,321.45c-23.05-10.7-57.42-9.9-78.54,1.49-.89.48-1.78,1-2.63,1.51-20.79,12.8-18.17,32.22,5.86,43.38s60.38,9.83,81.18-3c.84-.52,1.65-1.06,2.42-1.6C416.74,350.47,413.38,332.16,390.32,321.45Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65,322.49c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.76-2,1.15a34.42,34.42,0,0,0-9.21,7.94c-5.22,6.69-5.54,14.17-1.16,20.93,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.58-1,2.32-1.53c.21-.15.41-.29.61-.45,4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.48,45.48,0,0,0,388.65,322.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65,322.49c-.74-.35-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.76-2,1.15a34.42,34.42,0,0,0-9.21,7.94c-5.22,6.69-5.54,14.17-1.16,20.93,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.05,71.05,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a59.16,59.16,0,0,0,6.79-3c1-.53,2-1.1,3-1.68s1.58-1,2.32-1.53c.21-.15.41-.29.61-.45,4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.48,45.48,0,0,0,388.65,322.49Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,328c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.6,17.6,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.66-.2.16-.4.3-.61.45-.74.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.45-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.73,34.73,0,0,1,9.21-7.94c.65-.39,1.31-.78,2-1.15l.53-.29C333.13,319.85,364.44,318.78,386.4,328Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,328c.78.32,1.53.65,2.27,1a45.39,45.39,0,0,1,11.26,7.18c4.07,3.65,6.54,7.68,7.4,11.8a17.6,17.6,0,0,1-.66,2.38c-1.48,4.11-4.63,8.1-9.49,11.66-.2.16-.4.3-.61.45-.74.51-1.51,1-2.32,1.53s-1.94,1.15-3,1.68a59.16,59.16,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.05,71.05,0,0,1-7.55-2.51c-1.15-.45-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.94,18.94,0,0,1-2.69-6.36,19.57,19.57,0,0,1,3.87-8.11,34.73,34.73,0,0,1,9.21-7.94c.65-.39,1.31-.78,2-1.15l.53-.29C333.13,319.85,364.44,318.78,386.4,328Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.35,353c-8.73,19.43-33.18,27.18-53.11,30.68-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.23,6.24,15.18,12.61,20.33l0,0c18.87,14.63,45,19.36,70,18.66C383.39,384.82,416.93,378,428.35,353Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,359c8.56,3.58,16.95,2,24.77-.74l-2.06,2.12v8.88a35.77,35.77,0,0,0,5.29.87,38.59,38.59,0,0,0,9.21-.35A49,49,0,0,0,372.47,365l7.55,3.16,10.18-6.26V353l-1.92-.82-.41-.17a8.16,8.16,0,0,0,.21-2.08,5.21,5.21,0,0,0-.06-.7c-.13-1.1.09-6.11.06-8.18,0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-.94.33-1.87.68-2.78,1.05l2.68-2.81v-8.88c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67v8.89l2.36,1a5.49,5.49,0,0,0-.23,1.68v.07c.07,1.38-.06,7.26,0,8.82v.06C314.3,354.79,316.45,357.1,320.91,359Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,341.5c0,2.27-.16,6.75-.05,7.76,0,.25.05.47.07.71a8.33,8.33,0,0,1-.22,2.09l-5.42-2.28S387.92,347.13,388.07,341.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.35,341.36c-2.26-.95-2.64-2.71,1.52-5.39,4.46-2.82,9.05-3.56,12.95-2.58l8.82-9.19,0,8.87-2.66,2.8c-.1,0-.17.08-.27.11-1.45.55-2.85,1.13-4.19,1.68-.54.24-1.07.46-1.59.67a55.16,55.16,0,0,1-8.9,3.26,9.81,9.81,0,0,1-3.85.27A7.16,7.16,0,0,1,333.35,341.36Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,341.53l-2.35-1,0-8.88,7.51,3.15C316.73,337.13,314.94,339.4,314.35,341.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,359.3,390.2,353v8.89L380,368.2,372.49,365a48.5,48.5,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.88a36,36,0,0,0,14.5.5,48.78,48.78,0,0,0,14.36-4.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,365a36.94,36.94,0,0,1-11.44,4.69,30.51,30.51,0,0,1-12.13.39,57.12,57.12,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S370.56,365.76,372.49,365Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,352.17v-.05c-.07-1.57.07-7.45,0-8.84.16,2.63,2.28,4.94,6.75,6.8,9.94,4.15,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.85,19-4.85,3,1.26,2.15,3.26-1.13,5.36a18.19,18.19,0,0,1-14.2,2.23l-7.32,7.55h0c-7.83,2.77-16.21,4.29-24.75.72C316.43,357.11,314.31,354.79,314.15,352.17Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.82 342.27 347.82 333.39 356.63 324.19 356.63 333.07 347.82 342.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.82 342.27 347.82 333.39 356.63 324.19 356.63 333.07 347.82 342.27",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312 331.67 319.54 334.81 314.37 341.54 312.01 340.56 312 331.67",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312 331.67 319.54 334.81 314.37 341.54 312.01 340.56 312 331.67",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,352.22l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.58l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67l7.54,3.14c-3.6,3-5.49,5.84-5.4,8.41v.07c.14,2.61,2.29,4.93,6.75,6.79,9.92,4.15,19.6,1.43,28.44-2.13,8.22-3.33,14.19-6.86,19-4.84,3,1.26,2.14,3.25-1.15,5.35A18.19,18.19,0,0,1,353,350.7l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.35,48.92,48.92,0,0,0,14.35-4.72l7.54,3.17L390.19,353Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,352.22l-5.82-2.45s5.73-2.77,5.62-8.68c0-.25,0-.48-.07-.71-.3-2.48-2.36-4.71-6.58-6.46v0A27.29,27.29,0,0,0,368,332.1l-1.15.15h-.12l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.15-4.2,1.7l-1.59.67a55.79,55.79,0,0,1-8.9,3.26,10.2,10.2,0,0,1-3.85.27,8.1,8.1,0,0,1-1.81-.5c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.58l8.81-9.2c-8.67-1.66-17.92-.25-27,4.2l-7.55-3.15L312,331.67l7.54,3.14c-3.6,3-5.49,5.84-5.4,8.41v.07c.14,2.61,2.29,4.93,6.75,6.79,9.92,4.15,19.6,1.43,28.44-2.13,8.22-3.33,14.19-6.86,19-4.84,3,1.26,2.14,3.25-1.15,5.35A18.19,18.19,0,0,1,353,350.7l-9.38,9.65a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.35,48.92,48.92,0,0,0,14.35-4.72l7.54,3.17L390.19,353Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,350.08a28.49,28.49,0,0,0,11.81,1.84,43.81,43.81,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.63a40.08,40.08,0,0,1,6-2,9.92,9.92,0,0,1,6,.36,9.8,9.8,0,0,0-6-.09,39,39,0,0,0-5.85,2.12c-3.82,1.66-7.63,3.4-11.6,4.76a42.4,42.4,0,0,1-12.23,2.45,28.91,28.91,0,0,1-6.11-.46A29.61,29.61,0,0,1,320.9,350.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.01 359.31 380.02 368.19 372.47 365.03 372.47 356.14 380.01 359.31",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.01 359.31 380.02 368.19 372.47 365.03 372.47 356.14 380.01 359.31",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.19 353.04 380.05 358.31 372.47 356.14 380.01 359.31 390.19 353.04",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.61 328.39 322.11 326.16 312 331.67 322.06 325.24 329.61 328.39",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,324.19a37.39,37.39,0,0,0-4.74-.56l1.24,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,350.21a27.57,27.57,0,0,0,13,1.83L327,327.29l-4.91-2.05-6.86,4.38,1.13,3.86,3.21,1.33a24.84,24.84,0,0,0-2.21,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,333.32a26.37,26.37,0,0,0-7.49-1.36l8,27.12,6-3.7-1.32-4.52-2.6-1.09a11,11,0,0,0,1.9-1.27Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.69,332.26l-1.2.19c-.35.06-.7.12-1.05.2l-.42.09c-.27.05-.55.11-.8.18a62.61,62.61,0,0,0-6.49,1.91l-1.39.52,2.63,9c4-1.6,7.43-2.44,10.37-1.21s2.14,3.25-1.15,5.35a17.76,17.76,0,0,1-7.24,2.62l2.6,8.83a51.31,51.31,0,0,0,9.92-3.77l2.84,1.2-7.4-25.23-1.1.14Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.78,322.44l8.47,0v17.33h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.15,42.15,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a58.9,58.9,0,0,1-5.1,3.47c-1.91,1.17-3.92,2.26-6,3.29q-2.37,1.16-4.87,2.19C367.8,382.47,334,383.7,307,375.48q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.58-1.82-3.76-2.76h0a40.48,40.48,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,88.65,88.65,0,0,1,9.44-3.85c22.17-7.67,50.42-8.7,74.41-2.74a107.91,107.91,0,0,1,10.38,3.12c2.78,1,5.48,2.1,8.07,3.31a71.33,71.33,0,0,1,10.64,6.08A48.35,48.35,0,0,1,413.78,322.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,379.23l0-35.18,12.88,1.35,0,35.22C332.16,380.35,327.85,379.89,323.62,379.23Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.25,339.74h0a22.46,22.46,0,0,1-.83,6.16c-.2.7-.43,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.33.37-.69.75-1.05,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.3,323.57l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,379.88l0-45.7,12.88.95,0,42.55A129.86,129.86,0,0,1,362.26,379.88Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,323l7.75,0c.62-.68,1.27-1.35,2-2a54.74,54.74,0,0,1,9.33-7.07,74.22,74.22,0,0,1,6.67-3.6,88.65,88.65,0,0,1,9.44-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.91-.47-3.8-1-5.65-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.91-3.77-1.85-5.5-2.83-1.49-.86-2.91-1.73-4.24-2.64s-2.58-1.82-3.76-2.76h0a40.48,40.48,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.37,353.46c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0a.94.94,0,0,1,.1-.1l2.61.94,0,36.46A38.1,38.1,0,0,1,272.37,353.46Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.81,291.6c-2.59-1.21-5.29-2.32-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93A23.25,23.25,0,0,0,268,325.29a24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2a40.28,40.28,0,0,0,8.39,8.93h0q1.75,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63,1.73,1,3.56,1.93,5.49,2.83q3.56,1.66,7.35,3,2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14q2.51-1,4.88-2.19c2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47,45.44,45.44,0,0,0,3.5-2.92,40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,395.81,291.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.68,360c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.41-1.81q-3.79-1.38-7.35-3c-1.93-.9-3.76-1.85-5.49-2.83-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0a40.28,40.28,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.25,23.25,0,0,1,2.65-13.93,34.4,34.4,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19,343.17a37.82,37.82,0,0,1-5.84-6.73c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.66,22.66,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.46,363.6c-4.33-.26-8.64-.72-12.86-1.38l-21.71-73.93,1.06-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,360.67a127.2,127.2,0,0,1-12.88,2.19l-23.89-81.37c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.89,357.7c-2.12.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,293.53h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.69.44,1.36.88,2,1.33a46.2,46.2,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26c-.19.7-.43,1.4-.69,2.1a30.67,30.67,0,0,1-5.91,9.46c-.34.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,299.41c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C409.09,328.42,405.73,310.11,382.68,299.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,299.41c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.78,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C409.09,328.42,405.73,310.11,382.68,299.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,300.44c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.21,74.21,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,381,300.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,300.44c-.74-.34-1.49-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.76,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a74.21,74.21,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.69s1.59-1,2.32-1.52l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,381,300.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,305.91c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a74.21,74.21,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.39,19.39,0,0,1,3.87-8.11,34.4,34.4,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C325.49,297.81,356.79,296.74,378.76,305.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,305.91c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.67,7.39,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a74.21,74.21,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.39,19.39,0,0,1,3.87-8.11,34.4,34.4,0,0,1,9.21-7.93c.64-.4,1.31-.78,2-1.15l.53-.29C325.49,297.81,356.79,296.74,378.76,305.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.71,331c-8.74,19.43-33.19,27.18-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l.05,0c-6.37-5-11.79-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C375.75,362.77,409.29,356,420.71,331Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,336.92c8.56,3.59,16.95,2,24.77-.73L336,338.3v8.89a37.08,37.08,0,0,0,5.29.86,38,38,0,0,0,9.21-.34A49.22,49.22,0,0,0,364.83,343l7.54,3.17,10.18-6.27V331l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.12.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-.93.33-1.86.68-2.78,1L349,311v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43v8.88l2.36,1a5.47,5.47,0,0,0-.22,1.68v.06c.08,1.38-.06,7.26,0,8.82v.07C306.65,332.74,308.8,335.06,313.26,336.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.43,319.46c0,2.27-.17,6.74-.05,7.76,0,.24,0,.46.06.71a8.3,8.3,0,0,1-.22,2.08l-5.42-2.28S380.27,325.09,380.43,319.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7,319.32c-2.26-.95-2.63-2.71,1.53-5.39,4.45-2.83,9-3.56,12.94-2.59l8.82-9.19V311l-2.67,2.8-.27.11c-1.45.55-2.85,1.12-4.18,1.68-.55.24-1.08.46-1.6.66a55,55,0,0,1-8.89,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,325.7,319.32Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,319.48l-2.34-1v-8.88l7.51,3.15C309.08,315.09,307.29,317.36,306.7,319.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,337.25,382.55,331v8.89l-10.2,6.28L364.84,343a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51V338.3a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,343a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.9-1,5.84-1.6S362.91,343.71,364.84,343Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.51,330.12v-.05c-.06-1.56.07-7.44,0-8.83.15,2.62,2.28,4.94,6.74,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24L338,336.19h0c-7.84,2.77-16.22,4.3-24.76.73C308.79,335.06,306.66,332.75,306.51,330.12Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 320.23 340.17 311.34 348.98 302.14 348.99 311.03 340.18 320.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 320.23 340.17 311.34 348.98 302.14 348.99 311.03 340.18 320.23",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 309.63 311.89 312.77 306.72 319.5 304.36 318.51 304.35 309.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 309.63 311.89 312.77 306.72 319.5 304.36 318.51 304.35 309.63",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,330.18l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.66a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.83-5.39,8.41v.06c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.23-3.33,14.19-6.86,19-4.85,3,1.27,2.13,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24L336,338.3a36.11,36.11,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16L382.55,331Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,330.18l-5.83-2.45s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.33,27.33,0,0,0-13.48-1.79l-1.14.14H359l-1.2.2c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.66a57.37,57.37,0,0,1-8.89,3.27,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43,7.54,3.14c-3.59,3-5.49,5.83-5.39,8.41v.06c.15,2.62,2.29,4.93,6.76,6.8,9.91,4.15,19.59,1.42,28.43-2.13,8.23-3.33,14.19-6.86,19-4.85,3,1.27,2.13,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24L336,338.3a36.11,36.11,0,0,0,5.3.87,38.59,38.59,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16L382.55,331Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,328a28.43,28.43,0,0,0,11.8,1.83,43.23,43.23,0,0,0,12.05-2.55c3.94-1.3,7.73-3,11.6-4.62a39.32,39.32,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.84,9.84,0,0,0-6-.08,40.5,40.5,0,0,0-5.85,2.11c-3.81,1.67-7.63,3.41-11.6,4.76A42.35,42.35,0,0,1,325,330.31a28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,313.26,328Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.36 337.26 372.37 346.15 364.83 342.98 364.82 334.1 372.36 337.26",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.36 337.26 372.37 346.15 364.83 342.98 364.82 334.1 372.36 337.26",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.55 331 372.4 336.27 364.82 334.1 372.36 337.26 382.55 331",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.96 306.34 314.46 304.12 304.35 309.63 314.42 303.2 321.96 306.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,302.14a39.38,39.38,0,0,0-4.73-.56l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.6,328.17a27.56,27.56,0,0,0,13,1.82l-7.27-24.75-4.9-2-6.86,4.38,1.13,3.85,3.2,1.34a28.06,28.06,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,311.28a26.33,26.33,0,0,0-7.49-1.37l8,27.12,6-3.69-1.33-4.52-2.6-1.09a11.74,11.74,0,0,0,1.91-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,310.21l-1.2.2c-.35.06-.7.12-1,.2-.15,0-.3.05-.43.09s-.55.1-.79.17a62.1,62.1,0,0,0-6.5,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.06-1.6,7.43-2.45,10.38-1.22s2.13,3.25-1.15,5.36a17.7,17.7,0,0,1-7.24,2.61l2.59,8.84a51.72,51.72,0,0,0,9.92-3.77l2.85,1.19-7.41-25.22-1.09.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.13,302.68l8.47,0V320h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46,42.34,42.34,0,0,1-3,3,45.44,45.44,0,0,1-3.5,2.92,58.9,58.9,0,0,1-5.1,3.47c-1.92,1.17-3.92,2.26-6,3.29-1.58.77-3.2,1.5-4.88,2.19-24.52,10.13-58.33,11.36-85.31,3.14q-2.76-.84-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.37-5.5-2.83c-1.5-.86-2.91-1.73-4.25-2.64s-2.58-1.82-3.75-2.76h0a40.72,40.72,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V303.25l7.75,0c.62-.68,1.27-1.35,2-2a54.34,54.34,0,0,1,9.33-7.07,72.88,72.88,0,0,1,6.67-3.6,88.48,88.48,0,0,1,9.43-3.85c22.18-7.67,50.42-8.7,74.42-2.74a107.71,107.71,0,0,1,10.37,3.12c2.79,1,5.49,2.1,8.08,3.31a70.71,70.71,0,0,1,10.63,6.08A49,49,0,0,1,433.13,302.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,359.47l0-35.18,12.88,1.35,0,35.22C351.51,360.59,347.2,360.13,343,359.47Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,320h0a23.25,23.25,0,0,1-.83,6.16c-.2.7-.44,1.4-.7,2.1a30.6,30.6,0,0,1-5.91,9.46c-.34.37-.7.75-1.06,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,303.81l6.61-1.56,0,52.72c-2.11.7-4.27,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,360.12l0-45.7,12.87.95,0,42.55A129.56,129.56,0,0,1,381.6,360.12Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,303.25l7.75,0c.62-.68,1.27-1.35,2-2a54.34,54.34,0,0,1,9.33-7.07,72.88,72.88,0,0,1,6.67-3.6,88.48,88.48,0,0,1,9.43-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.9-.47-3.79-1-5.64-1.55s-3.64-1.16-5.4-1.81c-2.53-.92-5-1.94-7.35-3.05q-2.91-1.37-5.5-2.83c-1.5-.86-2.91-1.73-4.25-2.64s-2.58-1.82-3.75-2.76h0a40.72,40.72,0,0,1-8.39-8.93c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.71,333.7c-.44-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.68,23.68,0,0,1-.18-2.91h0V303.25l7.75,0,.09-.1,2.62.94,0,36.46A38.58,38.58,0,0,1,291.71,333.7Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,271.84c-2.59-1.21-5.29-2.32-8.08-3.31-3.34-1.19-6.81-2.24-10.37-3.12-24-6-52.24-4.93-74.42,2.74a88.48,88.48,0,0,0-9.43,3.85,72.88,72.88,0,0,0-6.67,3.6,54.34,54.34,0,0,0-9.33,7.07A34.19,34.19,0,0,0,290,291.6a23.1,23.1,0,0,0-2.65,13.93,25.08,25.08,0,0,0,3.1,9.12c.39.68.81,1.36,1.26,2a40,40,0,0,0,8.39,8.93h0q1.77,1.42,3.76,2.77c1.34.9,2.75,1.78,4.25,2.63,1.72,1,3.56,1.93,5.49,2.84,2.36,1.1,4.82,2.12,7.35,3q2.64,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.67-.69,3.3-1.42,4.87-2.19q3.15-1.53,6-3.29a60.27,60.27,0,0,0,5.09-3.47c1.26-.95,2.43-1.93,3.51-2.92a38.34,38.34,0,0,0,3-3,30.49,30.49,0,0,0,5.91-9.46c.27-.7.5-1.4.7-2.1a22.71,22.71,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.28,46.28,0,0,0-9.22-8.34A70.71,70.71,0,0,0,415.16,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,340.27c-1.92-.48-3.82-1-5.68-1.57s-3.65-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3-1.93-.91-3.77-1.86-5.49-2.84-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.76-2.77h0a40,40,0,0,1-8.39-8.93c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12A23.1,23.1,0,0,1,290,291.6a34.19,34.19,0,0,1,6.87-8.93,54.34,54.34,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,323.41a38.15,38.15,0,0,1-5.83-6.73c-.45-.67-.87-1.35-1.26-2a25.08,25.08,0,0,1-3.1-9.12A22.66,22.66,0,0,1,288.9,294Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,343.84c-4.33-.26-8.63-.72-12.86-1.38l-21.7-73.93,1.05-.38a107.42,107.42,0,0,1,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46,340.91a127,127,0,0,1-12.87,2.19l-23.9-81.37c4.5-.2,9-.19,13.54,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.23,337.94c-2.12.7-4.29,1.35-6.51,1.93l-22.85-77.8c2.46.2,4.9.45,7.32.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,273.77h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.68.44,1.36.88,2,1.33a46.28,46.28,0,0,1,9.22,8.34,27.47,27.47,0,0,1,6.37,13.6,22.71,22.71,0,0,1-.63,9.26c-.2.7-.43,1.4-.7,2.1a30.49,30.49,0,0,1-5.91,9.46c-.33.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,279.65c-23-10.7-57.42-9.9-78.54,1.48-.89.49-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.39s60.38,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C428.44,308.66,425.08,290.35,402,279.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,279.65c-23-10.7-57.42-9.9-78.54,1.48-.89.49-1.78,1-2.63,1.51-20.79,12.81-18.17,32.23,5.86,43.39s60.38,9.82,81.17-3c.85-.52,1.66-1.06,2.43-1.6C428.44,308.66,425.08,290.35,402,279.65Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,280.68c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.22,1.18,3.43,1.74s2.22,1,3.38,1.45a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.21,56.89-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.58-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,400.35,280.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,280.68c-.74-.34-1.5-.68-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.53.29c-.67.37-1.34.75-2,1.15a34.22,34.22,0,0,0-9.21,7.93c-5.22,6.7-5.54,14.17-1.16,20.94,2.57,4,6.76,7.68,12.54,10.85,1.08.6,2.22,1.18,3.43,1.74s2.22,1,3.38,1.45a74,74,0,0,0,7.54,2.51c18.19,5,40.23,4.21,56.89-2.09a60.94,60.94,0,0,0,6.79-3c1-.54,2-1.1,3-1.69s1.58-1,2.32-1.52l.61-.45c4.86-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.4-6.76-20.64A45.49,45.49,0,0,0,400.35,280.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1,286.15c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.74.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.09a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.63,19.63,0,0,1,3.87-8.11,34.71,34.71,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.15l.53-.29C344.83,278.05,376.14,277,398.1,286.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.1,286.15c.78.32,1.53.65,2.27,1a45.12,45.12,0,0,1,11.26,7.19c4.07,3.64,6.54,7.67,7.4,11.79a17.34,17.34,0,0,1-.66,2.39c-1.48,4.11-4.63,8.1-9.49,11.66l-.61.45c-.74.51-1.51,1-2.32,1.52s-1.94,1.15-3,1.69a60.94,60.94,0,0,1-6.79,3c-16.66,6.3-38.7,7.11-56.89,2.09a74,74,0,0,1-7.54-2.51c-1.16-.46-2.28-.94-3.38-1.45s-2.35-1.14-3.43-1.74c-5.78-3.17-10-6.89-12.54-10.85a19,19,0,0,1-2.69-6.37,19.63,19.63,0,0,1,3.87-8.11,34.71,34.71,0,0,1,9.21-7.93c.65-.4,1.31-.78,2-1.15l.53-.29C344.83,278.05,376.14,277,398.1,286.15Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.05,311.22c-8.73,19.44-33.18,27.18-53.11,30.69-30.3,4.35-63.28.7-86.71-16.54l0,0c-6.37-5-11.8-11.73-12.94-19.87,1,8.22,6.24,15.18,12.61,20.32l0,0c18.87,14.62,45,19.36,70,18.66C395.09,343,428.63,336.24,440.05,311.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.61,317.16c8.56,3.59,16.95,2,24.77-.73l-2.06,2.11v8.89a37.08,37.08,0,0,0,5.29.86,38.08,38.08,0,0,0,9.21-.34,49.06,49.06,0,0,0,14.34-4.73l7.55,3.17,10.18-6.27v-8.88l-1.91-.82-.41-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.09-6.12,0-8.19a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.94.33-1.87.68-2.78,1l2.68-2.8v-8.89c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43v8.88l2.36,1a5.49,5.49,0,0,0-.23,1.68v.06c.08,1.38,0,7.26,0,8.82v.07C326,313,328.15,315.3,332.61,317.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.77,299.7c0,2.27-.16,6.74,0,7.76,0,.24,0,.47.07.71a8.3,8.3,0,0,1-.22,2.08L394.15,308S399.62,305.33,399.77,299.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.05,299.56c-2.27-.95-2.64-2.71,1.52-5.39,4.46-2.83,9.05-3.56,12.95-2.59l8.82-9.19,0,8.88-2.66,2.8c-.1,0-.17.07-.27.11-1.45.55-2.85,1.12-4.19,1.68q-.81.36-1.59.66a55.38,55.38,0,0,1-8.9,3.27,10,10,0,0,1-3.85.27A7,7,0,0,1,345.05,299.56Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,299.72l-2.35-1,0-8.88,7.51,3.15C328.43,295.33,326.64,297.6,326.05,299.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.71,317.49l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.89a36.15,36.15,0,0,0,14.5.51,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,323.22a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.49,58.49,0,0,0,11.95-1.4c2-.43,3.91-1,5.85-1.6S382.26,324,384.19,323.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,310.36v-.05c-.07-1.56.07-7.44,0-8.83.16,2.62,2.28,4.94,6.75,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.17,18.17,0,0,1-14.21,2.24l-7.31,7.54h0c-7.83,2.77-16.21,4.3-24.75.73C328.13,315.3,326,313,325.85,310.36Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.52 300.47 359.52 291.58 368.33 282.38 368.33 291.27 359.52 300.47",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.52 300.47 359.52 291.58 368.33 282.38 368.33 291.27 359.52 300.47",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.7 289.87 331.24 293.01 326.07 299.74 323.71 298.75 323.7 289.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.7 289.87 331.24 293.01 326.07 299.74 323.71 298.75 323.7 289.87",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,310.42,394.16,308s5.73-2.78,5.61-8.69a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.14-4.2,1.7-.55.24-1.07.45-1.59.66a57.41,57.41,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.4,8.41v.06c.15,2.62,2.3,4.93,6.76,6.8,9.92,4.15,19.6,1.42,28.44-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36,36,0,0,0,5.29.87,38.55,38.55,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.16,10.18-6.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,310.42,394.16,308s5.73-2.78,5.61-8.69a5.21,5.21,0,0,0-.06-.7c-.3-2.48-2.36-4.71-6.58-6.47v0a27.29,27.29,0,0,0-13.47-1.79l-1.15.14-.12,0-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-1,.36-2,.74-3,1.14-1.45.56-2.86,1.14-4.2,1.7-.55.24-1.07.45-1.59.66a57.41,57.41,0,0,1-8.9,3.27,10.18,10.18,0,0,1-3.85.26,8.08,8.08,0,0,1-1.81-.49c-2.27-.95-2.65-2.72,1.53-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.2c-8.67-1.65-17.92-.25-27,4.2l-7.55-3.14-10.06,6.43,7.54,3.14c-3.6,3-5.49,5.83-5.4,8.41v.06c.15,2.62,2.3,4.93,6.76,6.8,9.92,4.15,19.6,1.42,28.44-2.13,8.22-3.33,14.19-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.19,18.19,0,0,1-14.19,2.24l-9.38,9.64a36,36,0,0,0,5.29.87,38.55,38.55,0,0,0,9.21-.35,49.21,49.21,0,0,0,14.35-4.72l7.54,3.16,10.18-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,308.28a28.48,28.48,0,0,0,11.81,1.83,43.09,43.09,0,0,0,12-2.55c3.95-1.3,7.74-3,11.61-4.62a39,39,0,0,1,6-2,9.84,9.84,0,0,1,6,.35,9.8,9.8,0,0,0-6-.08,40.08,40.08,0,0,0-5.85,2.11c-3.82,1.67-7.64,3.41-11.6,4.76a42.42,42.42,0,0,1-12.23,2.46,28.91,28.91,0,0,1-6.11-.46A29.39,29.39,0,0,1,332.6,308.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 317.5 391.71 326.39 384.17 323.22 384.17 314.34 391.71 317.5",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 317.5 391.71 326.39 384.17 323.22 384.17 314.34 391.71 317.5",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.89 311.24 391.75 316.51 384.17 314.34 391.71 317.5 401.89 311.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.31 286.58 333.81 284.36 323.7 289.87 333.76 283.44 341.31 286.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,282.38a39.3,39.3,0,0,0-4.74-.56l1.24,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,308.41a27.56,27.56,0,0,0,13,1.82l-7.27-24.75-4.91-2-6.86,4.38,1.13,3.85,3.21,1.34a26.39,26.39,0,0,0-2.21,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.61,291.52a26.39,26.39,0,0,0-7.49-1.37l8,27.12,6-3.69-1.32-4.52-2.6-1.09a10.71,10.71,0,0,0,1.9-1.28Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,290.46l-1.2.19c-.35.06-.7.12-1.05.2-.15,0-.3,0-.42.09-.27.05-.55.1-.8.17a62.64,62.64,0,0,0-6.49,1.92c-.47.16-.93.35-1.39.52l2.63,9c4.05-1.6,7.43-2.45,10.37-1.22s2.14,3.25-1.15,5.36a17.59,17.59,0,0,1-7.24,2.61l2.6,8.84a52,52,0,0,0,9.92-3.77l2.84,1.19-7.4-25.22-1.1.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "296.81 380.6 298.04 371.28 299.27 380.6 315.41 381.31 299.27 382.02 298.04 391.34 296.81 382.02 280.67 381.31 296.81 380.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.85 388.59 309.45 384.08 310.04 388.59 317.87 388.94 310.04 389.28 309.45 393.8 308.85 389.28 301.03 388.94 308.85 388.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.49 291.58 282.72 282.26 283.94 291.58 300.09 292.29 283.94 293 282.72 302.32 281.49 293 265.34 292.29 281.49 291.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.21 298.81 290.81 294.29 291.4 298.81 299.23 299.15 291.4 299.5 290.81 304.01 290.21 299.5 282.39 299.15 290.21 298.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.29 331.78 414.52 322.46 415.75 331.78 431.89 332.49 415.75 333.2 414.52 342.52 413.29 333.2 397.15 332.49 413.29 331.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.02 339.01 422.61 334.49 423.21 339.01 431.03 339.35 423.21 339.69 422.61 344.21 422.02 339.69 414.19 339.35 422.02 339.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215,392l8.47,0v17.34h0a22.44,22.44,0,0,1-.83,6.15c-.2.7-.43,1.4-.7,2.1A30.6,30.6,0,0,1,216,427a42.15,42.15,0,0,1-3,3c-1.08,1-2.25,2-3.51,2.92a58.9,58.9,0,0,1-5.1,3.47c-1.91,1.17-3.92,2.26-6,3.29-1.57.77-3.2,1.5-4.87,2.19C169,452,135.22,453.21,108.25,445q-2.77-.84-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.92-1.73-4.25-2.64s-2.58-1.82-3.76-2.76h0A40.26,40.26,0,0,1,73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0c.62-.68,1.27-1.35,2-2a54.44,54.44,0,0,1,9.34-7.07,72.7,72.7,0,0,1,6.66-3.6,88.65,88.65,0,0,1,9.44-3.85c22.17-7.67,50.42-8.7,74.41-2.74A107.91,107.91,0,0,1,189,376.34c2.78,1,5.48,2.1,8.07,3.31a70.48,70.48,0,0,1,10.64,6.09A48.31,48.31,0,0,1,215,392Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85,448.74l0-35.17,12.88,1.34,0,35.22C133.39,449.86,129.08,449.4,124.85,448.74Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,409.26h0a22.44,22.44,0,0,1-.83,6.15c-.2.7-.43,1.4-.7,2.1A30.6,30.6,0,0,1,216,427c-.33.37-.69.75-1,1.12l0-36.2.06.06,8.47,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,393.08l6.61-1.56,0,52.72c-2.1.7-4.26,1.33-6.47,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,449.39l0-45.7,12.88.95,0,42.55A130.06,130.06,0,0,1,163.49,449.39Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,392.52l7.75,0c.62-.68,1.27-1.35,2-2a54.44,54.44,0,0,1,9.34-7.07,72.7,72.7,0,0,1,6.66-3.6,88.65,88.65,0,0,1,9.44-3.85c3.1-1.07,6.33-2,9.64-2.81l.06,73.39c-1.91-.47-3.8-1-5.64-1.55s-3.65-1.16-5.41-1.81c-2.53-.92-5-1.94-7.35-3.05-1.93-.9-3.77-1.85-5.49-2.83-1.5-.86-2.92-1.73-4.25-2.64s-2.58-1.82-3.76-2.76h0A40.26,40.26,0,0,1,73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,423c-.45-.67-.87-1.35-1.26-2a25.1,25.1,0,0,1-3.11-9.12,23.67,23.67,0,0,1-.17-2.91h0l0-16.39,7.75,0a.94.94,0,0,1,.1-.1l2.61.95,0,36.45A38.1,38.1,0,0,1,73.6,423Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,361.11c-2.59-1.21-5.29-2.31-8.08-3.31a106.86,106.86,0,0,0-10.37-3.12c-24-6-52.24-4.93-74.41,2.74a88.65,88.65,0,0,0-9.44,3.85,74.22,74.22,0,0,0-6.67,3.6,54.74,54.74,0,0,0-9.33,7.07,34.4,34.4,0,0,0-6.87,8.93,23.28,23.28,0,0,0-2.65,13.93,24.91,24.91,0,0,0,3.11,9.12c.38.68.8,1.36,1.25,2A40.28,40.28,0,0,0,82,414.88h0q1.76,1.42,3.75,2.77c1.34.9,2.75,1.78,4.25,2.63q2.59,1.47,5.5,2.84c2.36,1.1,4.81,2.12,7.34,3q2.66,1,5.41,1.81c27,8.23,60.78,7,85.31-3.14,1.68-.69,3.3-1.42,4.88-2.19,2.1-1,4.1-2.12,6-3.29a60.48,60.48,0,0,0,5.1-3.47A45.44,45.44,0,0,0,213,413a40.34,40.34,0,0,0,3-3,30.67,30.67,0,0,0,5.91-9.46c.26-.7.5-1.4.69-2.1a22.37,22.37,0,0,0,.63-9.26,27.47,27.47,0,0,0-6.37-13.6,46.2,46.2,0,0,0-9.21-8.34A71.33,71.33,0,0,0,197,361.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91,429.54c-1.92-.48-3.82-1-5.68-1.57s-3.64-1.16-5.4-1.81c-2.54-.92-5-1.94-7.35-3q-2.91-1.37-5.5-2.84c-1.5-.85-2.91-1.73-4.25-2.63s-2.58-1.82-3.75-2.77h0A40.28,40.28,0,0,1,73.58,406c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,23.28,23.28,0,0,1,2.65-13.93,34.4,34.4,0,0,1,6.87-8.93,54.74,54.74,0,0,1,9.33-7.07c1.88-1.15,3.86-2.21,5.91-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.42,412.68A37.82,37.82,0,0,1,73.58,406c-.45-.67-.87-1.35-1.25-2a24.91,24.91,0,0,1-3.11-9.12,22.77,22.77,0,0,1,1.56-11.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,433.12c-4.33-.27-8.64-.73-12.86-1.39L103.12,357.8l1.06-.38c3.34-1.15,6.83-2.14,10.41-3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,430.18a126.72,126.72,0,0,1-12.88,2.19L139.58,351c4.5-.2,9-.19,13.53,0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,427.21c-2.12.7-4.3,1.35-6.52,1.93l-22.84-77.8c2.45.2,4.89.45,7.31.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.86,363h0c1,.54,2,1.1,2.93,1.66l.94.56.94.6c.69.44,1.36.88,2,1.33a46.2,46.2,0,0,1,9.21,8.34,27.47,27.47,0,0,1,6.37,13.6,22.37,22.37,0,0,1-.63,9.26c-.19.7-.43,1.4-.69,2.1A30.67,30.67,0,0,1,216,410c-.34.38-.7.75-1.06,1.13Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.91,368.92c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.77,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.53,1.66-1.07,2.43-1.61C210.32,397.93,207,379.62,183.91,368.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.91,368.92c-23.06-10.7-57.42-9.9-78.55,1.48-.89.49-1.77,1-2.62,1.51-20.8,12.81-18.18,32.23,5.86,43.39s60.37,9.82,81.17-3c.85-.53,1.66-1.07,2.43-1.61C210.32,397.93,207,379.62,183.91,368.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,370c-.74-.34-1.49-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.77,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.82,71.82,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,182.23,370Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,370c-.74-.34-1.49-.67-2.27-1-22-9.17-53.27-8.1-72.78,2.41l-.52.29c-.68.37-1.34.75-2,1.15a34.4,34.4,0,0,0-9.21,7.93c-5.22,6.7-5.53,14.17-1.16,20.94,2.58,4,6.77,7.68,12.54,10.85,1.09.6,2.23,1.18,3.43,1.74s2.23,1,3.38,1.45a71.82,71.82,0,0,0,7.55,2.51c18.18,5,40.22,4.21,56.88-2.09a61.11,61.11,0,0,0,6.8-3c1-.54,2-1.1,3-1.68s1.59-1,2.32-1.53l.61-.45c4.87-3.56,8-7.55,9.49-11.66,2.52-7,.2-14.39-6.76-20.64A45.49,45.49,0,0,0,182.23,370Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,375.42c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.68,7.39,11.79a16,16,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.53s-1.94,1.14-3,1.68a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.82,71.82,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.77-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.29,19.29,0,0,1,3.87-8.1,34.24,34.24,0,0,1,9.21-7.94c.64-.4,1.31-.78,2-1.15l.53-.29C126.72,367.32,158,366.25,180,375.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,375.42c.77.32,1.53.65,2.27,1a45.49,45.49,0,0,1,11.26,7.19c4.06,3.64,6.53,7.68,7.39,11.79a16,16,0,0,1-.66,2.39c-1.48,4.11-4.62,8.1-9.49,11.66l-.61.45c-.73.51-1.51,1-2.32,1.53s-1.94,1.14-3,1.68a61.11,61.11,0,0,1-6.8,3c-16.66,6.3-38.7,7.11-56.88,2.09a71.82,71.82,0,0,1-7.55-2.51c-1.15-.46-2.27-.94-3.38-1.45s-2.34-1.14-3.43-1.74c-5.77-3.17-10-6.89-12.54-10.85a18.76,18.76,0,0,1-2.68-6.37,19.29,19.29,0,0,1,3.87-8.1,34.24,34.24,0,0,1,9.21-7.94c.64-.4,1.31-.78,2-1.15l.53-.29C126.72,367.32,158,366.25,180,375.42Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,400.49c-8.74,19.44-33.19,27.19-53.12,30.69-30.3,4.35-63.28.7-86.71-16.54l0,0c-6.37-5-11.79-11.73-12.94-19.87,1,8.22,6.24,15.18,12.62,20.32l0,0c18.87,14.62,45,19.36,70,18.66C177,432.29,210.52,425.51,221.94,400.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,406.43c8.56,3.59,17,2,24.77-.73l-2.06,2.12v8.88a37.22,37.22,0,0,0,5.3.86,38,38,0,0,0,9.2-.34,49.22,49.22,0,0,0,14.35-4.73l7.54,3.17,10.18-6.27v-8.88l-1.91-.82-.42-.17a8.2,8.2,0,0,0,.21-2.08,5.07,5.07,0,0,0-.06-.7c-.13-1.1.1-6.11.06-8.19,0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.35.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-.93.33-1.86.68-2.78,1l2.69-2.8v-8.89c-8.66-1.65-17.92-.25-27,4.2l-7.54-3.14-10.07,6.43V388l2.36,1a5.8,5.8,0,0,0-.22,1.68v.07c.08,1.37-.06,7.26,0,8.81v.07C107.88,402.26,110,404.57,114.49,406.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,389c0,2.27-.17,6.74,0,7.76,0,.24,0,.47.06.71a8.25,8.25,0,0,1-.22,2.08L176,397.24S181.51,394.6,181.66,389Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,388.83c-2.26-.95-2.63-2.71,1.53-5.39,4.46-2.83,9-3.56,12.94-2.59l8.82-9.19v8.88l-2.66,2.8-.28.11c-1.44.55-2.85,1.12-4.18,1.68q-.83.36-1.59.66a55.38,55.38,0,0,1-8.9,3.27,10.07,10.07,0,0,1-3.86.27A7.16,7.16,0,0,1,126.93,388.83Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,389l-2.34-1v-8.88l7.51,3.15C110.31,384.6,108.52,386.87,107.93,389Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.59,406.76l10.19-6.26v8.89l-10.2,6.28-7.52-3.18a48.79,48.79,0,0,1-14.36,4.72,36.15,36.15,0,0,1-14.5-.51v-8.88a36.47,36.47,0,0,0,14.5.5,48.5,48.5,0,0,0,14.36-4.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,412.49a37.16,37.16,0,0,1-11.44,4.68,30.33,30.33,0,0,1-12.13.4,58.58,58.58,0,0,0,12-1.4c2-.43,3.9-1,5.84-1.6S164.14,413.22,166.07,412.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,399.63v-.05c-.06-1.56.07-7.44,0-8.83.15,2.62,2.28,4.94,6.74,6.8,9.94,4.14,19.61,1.42,28.46-2.13,8.21-3.32,14.18-6.86,19-4.86,3,1.27,2.15,3.27-1.13,5.36a18.15,18.15,0,0,1-14.2,2.24l-7.32,7.54h0c-7.84,2.77-16.22,4.3-24.76.73C110,404.57,107.89,402.26,107.74,399.63Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.41 389.74 141.4 380.85 150.21 371.65 150.22 380.54 141.41 389.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.41 389.74 141.4 380.85 150.21 371.65 150.22 380.54 141.41 389.74",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.58 379.14 113.13 382.28 107.95 389.01 105.59 388.02 105.58 379.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.58 379.14 113.13 382.28 107.95 389.01 105.59 388.02 105.58 379.14",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,399.69,176,397.24s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.67a58.19,58.19,0,0,1-8.89,3.26,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.19c-8.66-1.66-17.92-.26-27,4.19l-7.54-3.14-10.07,6.43,7.55,3.14c-3.6,3-5.5,5.83-5.4,8.41v.07c.15,2.61,2.29,4.92,6.76,6.79,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.65a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,399.69,176,397.24s5.73-2.78,5.62-8.69c0-.25,0-.47-.07-.7-.29-2.48-2.36-4.71-6.57-6.47v0a27.31,27.31,0,0,0-13.48-1.79l-1.14.14-.13,0-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-1,.36-2,.74-3,1.14-1.44.56-2.86,1.14-4.2,1.7-.54.24-1.07.45-1.59.67a58.19,58.19,0,0,1-8.89,3.26,10.21,10.21,0,0,1-3.85.26,7.94,7.94,0,0,1-1.81-.49c-2.27-.95-2.66-2.72,1.52-5.4,4.45-2.84,9-3.57,12.94-2.59l8.81-9.19c-8.66-1.66-17.92-.26-27,4.19l-7.54-3.14-10.07,6.43,7.55,3.14c-3.6,3-5.5,5.83-5.4,8.41v.07c.15,2.61,2.29,4.92,6.76,6.79,9.91,4.15,19.59,1.42,28.44-2.13,8.22-3.33,14.18-6.86,19-4.85,3,1.27,2.14,3.25-1.15,5.36a18.22,18.22,0,0,1-14.2,2.24l-9.38,9.65a37.45,37.45,0,0,0,5.3.86,38.08,38.08,0,0,0,9.21-.35,49.15,49.15,0,0,0,14.34-4.72l7.54,3.16,10.19-6.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,397.55a28.6,28.6,0,0,0,11.8,1.84,43.61,43.61,0,0,0,12-2.56c3.94-1.3,7.73-3,11.6-4.62a39.32,39.32,0,0,1,6-2,9.88,9.88,0,0,1,6,.35,9.83,9.83,0,0,0-6-.08,40.5,40.5,0,0,0-5.85,2.11c-3.81,1.67-7.63,3.41-11.6,4.76a42.35,42.35,0,0,1-12.23,2.46,28.77,28.77,0,0,1-6.1-.46A29.17,29.17,0,0,1,114.49,397.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 406.77 173.6 415.66 166.06 412.5 166.05 403.61 173.59 406.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 406.77 173.6 415.66 166.06 412.5 166.05 403.61 173.59 406.77",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.78 400.51 173.63 405.78 166.05 403.61 173.59 406.77 183.78 400.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.19 375.85 115.69 373.63 105.58 379.14 115.65 372.71 123.19 375.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,371.66a37.46,37.46,0,0,0-4.73-.57l1.23,4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83,397.68a27.58,27.58,0,0,0,13,1.82l-7.27-24.74-4.9-2.05-6.86,4.38,1.13,3.85,3.21,1.34a26.6,26.6,0,0,0-2.22,2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,380.79a26,26,0,0,0-7.49-1.36l8,27.11,6-3.69-1.33-4.52-2.6-1.09A11,11,0,0,0,178,396Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,379.73l-1.2.19c-.34.06-.69.12-1,.2-.15,0-.3.05-.43.09a6.1,6.1,0,0,0-.79.18,59.76,59.76,0,0,0-6.5,1.91c-.47.16-.92.35-1.39.52l2.63,9c4.06-1.6,7.43-2.45,10.38-1.22s2.14,3.25-1.15,5.36a17.7,17.7,0,0,1-7.24,2.61l2.59,8.84a51.07,51.07,0,0,0,9.92-3.77l2.85,1.19-7.41-25.22c-.36,0-.74.1-1.09.13Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.06 390.64 74.29 381.32 75.52 390.64 91.66 391.35 75.52 392.06 74.29 401.38 73.06 392.06 56.91 391.35 73.06 390.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.78 397.87 82.38 393.35 82.97 397.87 90.8 398.21 82.97 398.55 82.38 403.07 81.78 398.55 73.96 398.21 81.78 397.87",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.0749a427c998fae48023960e028fbd6a.svg";
export { ForwardRef as ReactComponent };